import { ExpensesDialogComponent } from 'src/app/mobile/dialogs/farms/expenses-dialog/expenses-dialog.component';
import { SELECT_PANEL_VIEWPORT_PADDING } from '@angular/material/select/select';
import { __createBinding } from 'tslib';

// USA
export const locale = {
  lang: 'th',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'ภาพรวม',
      SECTION: {
        MEMBER: 'สมาชิก',
        RAW_MATERIAL: 'คงคลัง',
        MANAGE_FARMING: 'การผลิต',
        SETTING: 'ตั้งค่า',
        CONTRACT: 'สัญญา/รุ่น',
        ACCOUNT: 'บัญชี',
        REPORT: 'รายงาน',
      },
      MEMBER: {
        TITLE: 'ระบบจัดการสมาชิก',
        AGENT_INFORMATION: 'ข้อมูลสมาชิก',
        FARM_INFORMATION: 'ข้อมูลฟาร์ม',
        MESSAGING: 'การรับส่งข้อความ',
      },
      RAW_MATERIAL: {
        // TITLE: 'ระบบจัดการวัตถุดิบ/สินค้า',
        TITLE: 'คงคลัง',
        SUB_TITLE_ONE: 'ระบบการซื้อวัตถุดิบ/สินค้า',
        SUB_TITLE_TWO: 'ระบบการขายวัตถุดิบ/สินค้า',
        SUB_TITLE_THREE: 'ระบบจัดการวัตถุดิบ/สินค้า',
        PRE_ORDER: 'สั่งซื้อ',
        PURCHASE_ORDER: 'ซื้อวัตถุดิบ/สินค้า',
        RAW_MATERIAL_CLAIM: 'เคลมวัตถุดิบ/สินค้า',
        RETURN_ORDER: 'ส่งเคลม/ส่งคืน',
        RAW_MATERIAL_RECEIVING: 'รับเข้าวัตถุดิบ/สินค้า',
        RAW_MATERIAL_REQUISITION: 'เบิกวัตถุดิบ/สินค้า',
        RAW_MATERIAL_RETURN: 'คืนวัตถุดิบ/สินค้า',
        STOCK_ADJUST: 'ปรับปรุงสต็อก',
        RAW_MATERIAL_BID: 'เสนอราคา',
        RAW_MATERIAL_SELL: 'ขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
        RAW_MATERIAL_BUY: 'รับซื้อผลผลิต',
        RAW_MATERIAL_DEPOSIT: 'เงินมัดจำ',
        RAW_MATERIAL_RECEIVE_CLAIM: 'รับเคลม/รับคืน',
        RAW_MATERIAL_SEND_CLAIM: 'ส่งสินค้าที่เคลมให้ลูกค้า',
        REDUCE_DEBT: 'ลดหนี้',
        ADD_DEBT: 'เพิ่มหนี้',
        SEND_ORDER: 'ส่งของ',
      },
      ACCOUNT_SETTING: {
        TITLE: 'ระบบจัดการบัญชี',
        EXPENSES: 'ข้อมูลค่าใช้จ่าย',
        ACCEPT_DEBT: 'ข้อมูลการรับชำระหนี้',
        PAY_OFF_DEBT: 'ข้อมูลการจ่ายชำระหนี้',
        EMPLOYEE_WAGES: 'ข้อมูลค่าจ้างพนักงาน',
        MEMBER_DIVIEND_PAYMENT: 'ข้อมูลจ่ายเงินปันผลสมาชิก',
        OTHER_INCOME: 'บันทึกรายได้อื่น',
      },
      MANAGE_FARMING: {
        TITLE: 'ระบบการจัดการการผลิต',
        FARMING_TYPE: {
          TITLE: 'รูปแบบการผลิต',
          ACTIVITY_TYPE: 'ประเภทกิจกรรม',
          FARMING_ACTIVITY: 'กิจกรรมการผลิต',
          FARMING_TYPE: 'ข้อมูลพื้นฐานการผลิต',
          CROP_REQUIREMENT: 'ตั้งค่ามาตรฐาน',
          ACTIVITY: 'บันทึกกิจกรรม',
        },
        FARMING_INFORMATION: {
          TITLE: 'บันทึกข้อมูลการผลิต',
          FARMING_INFORMATION: 'บันทึกค่าการผลิต',
          EXPENSE_INFORMATION: 'บันทึกค่าใช้จ่าย',
          ENVIRONMENT_INFORMATION: 'บันทึกค่าสิ่งแวดล้อม',
          WASTING_INFORMATION: 'บันทึกการสูญเสีย',
          GROWTH_INFORMATION: 'บันทึกค่าการเจริญเติบโต',
          HAVEST_INFORMATION: 'บันทึกค่าการเก็บเกี่ยว',
        },
        PRODUCTION_PLAN: {
          TITLE: 'แผนการผลิต',
          ORDER_PLAN: 'รับเข้าออเดอร์',
          ANALYZE_ORDERS: 'การวิเคราะห์',
          REPORT_PLAN: 'รายงานแผนการผลิต',
        },
      },
      CONTRACT_LOT: {
        TITLE: 'ระบบการจัดการสัญญา / รุ่น',
        CONTRACT_INFORMATION: 'ข้อมูลสัญญา',
        LOT_INFORMATION: 'ข้อมูลรุ่น',
      },
      REPORT: {
        TITLE: 'รายงาน',
        WAREHOUSE_REPORT: {
          TITLE: 'รายงานคลังสินค้า',
          INVENTORY_REPORT: 'รายงานสินค้าคงเหลือ',
          CLAIM_REPORT: 'รายงานส่งเคลม/ส่งคืน',
          REPORT_BACK: 'รายงานรับเคลม/รับคืน',
        },
        ACCOUNTING_REPORT: {
          TITLE: 'รายงานการบริหาร (รายงานด้านบัญชี)',
          CASH_FLOW_STATEMENT: 'รายงานกระแสเงินสด',
          CREDITOR_REPORT: 'รายงานเจ้าหนี้',
          DEBTOR_REPORT: 'รายงานลูกหนี้',
          EXPENSES_REPORT: 'รายงานค่าใช้จ่าย',
          INCOME_STATEMENT: 'รายงานกำไรขาดทุน',
        },
        ANALYSIS_REPORT: {
          TITLE: 'รายงานวิเคราะห์เชิงลึก',
          CASH_FLOW_MANAGEMENT: 'Cash flow management',
          FARMING_REPORT: 'รายงานการวางแผนปลูก/เลี้ยง',
          FEED_FERTILIZE: 'รายงานการวางแผนการให้อาหาร/ใส่ปุ๋ย',
          HARVEST_REPORT: 'รายงานการวางแผนเก็บเกี่ยวผลผลิต',
          PERFORMANCE_ANALYSIS: 'รายงานวิเคราะห์ประสิทธิภาพ',
          PRODUCT_TRUCK: 'รายงานขนส่งสินค้า',
          PURCHASE_RAW_MATERIAL: 'รายงานการวางแผนจัดซื้อวัตถุดิบ/สินค้า',
          RAW_MATERIAL_TRUCK: 'รายงานส่งมอบสินค้า',
          STOCK_ADJUSTMENT: 'รายงานการบริหารจัดการสต๊อกผลผลิต',
        },
        ENVIRONMENT_REPORT: {
          TITLE: 'รายงานด้านสิ่งแวดล้อม',
          ENVIRONMENT_VALUE: 'รายงานค่าสิ่งแวดล้อม',
        },
        GENERAL_REPORT: {
          TITLE: 'รายงานทั่วไป',
          CLOSE_LOT_REPORT: 'รายงานการปิดรุ่น',
          CONTRACT_REPORT: 'รายงานสัญญา',
          PAY_DEVEDENDS_REPORT: 'รายงานการจ่ายปันผล',
          RECEIVE_MONEY_REPORT: 'รายงานการรับเงิน',
          TAX_REPORT: 'รายงานภาษี',
          PURCHASE_TAX_REPORT: 'รายงานภาษีซื้อ',
          SALE_TAX_REPORT: 'รายงานภาษีขาย',
          WAGE_REPORT: 'รายงานค่าแรง',
        },
        PRODUCTION_EFFICIENCY: {
          TITLE: 'รายงานประสิทธิภาพการผลิต',
          FEED_FERTILIZE_DRUG: 'รายงานการให้อาหาร/ใส่ปุ๋ย/ยา',
          GROWTH_REPORT: 'รายงานค่าการเจริญเติบโต',
          PRODUCT_COST: 'รายงานต้นทุนผลิตรวม',
          PRODUCT_COST_ACTIVITY_TYPE: 'รายงานต้นทุนผลิตแยกตามประเภทกิจกรรม',
          PRODUCT_QUANTITY: 'รายงานปริมาณผลผลิต',
          WASTING_REPORT: 'รายงานการสูญเสีย',
        },
        PURCHASE_REPORT: {
          TITLE: 'รายงานการซื้อ',
          PURCHASE_PRODUCT: 'รายงานซื้อผลผลิต',
          PURCHASE_RAW_MATERIAL: 'รายงานซื้อวัตถุดิบ',
        },
        SALES_REPORT: {
          TITLE: 'รายงานขายวัตถุดิบ อุปกรณ์และผลผลิต',
          SALES_PRODUCT: 'รายงานขายวัตถุดิบ อุปกรณ์และผลผลิต',
          SALES_RAW_MATERIAL: 'รายงานขายวัตถุดิบ',
        },
      },
      SETTING: {
        TITLE: 'การตั้งค่า',
        GENERAL_SETTING: {
          TITLE: 'ตั้งค่าทั่วไป',
          GENERAL_INFORMATION: 'ข้อมูลทั่วไป',
          CUSTOMER_INFORMATION: 'ข้อมูลลูกค้า',
          SUPPLIER_INFORMATION: 'ข้อมูลผู้จำหน่าย',
          ACCOUNT_INFORMATION: 'ข้อมูลบัญชีธนาคาร',
          EXPENSE_INFORMATION: 'รายการค่าใช้จ่าย',
          OTHER_INCOME: 'รายการรายได้อื่น',
        },
        STAFF_SETTING: {
          TITLE: 'ตั้งค่าพนักงาน',
          STAFF_INFORMATION: 'ข้อมูลพนักงาน',
          PERMISSION: 'สิทธิ์การเข้าถึง',
          POSITION: 'ตำแหน่งพนักงาน',
        },
        RAW_MATERIAL_SETTING: {
          TITLE: 'ตั้งค่าวัตถุดิบ/สินค้า',
          UNIT: 'หน่วยนับ',
          RAW_MATERIAL_TYPE: 'ประเภทวัตถุดิบ/ผลผลิต',
          RAW_MATERIAL_LIST: 'รายการวัตถุดิบ/ผลผลิต',
        },
        INITIAL_SETTING: {
          TITLE: 'ตั้งค่าตั้งต้น',
          INITIAL_CASH: 'ค่าตั้งต้นเงินสด',
          INITIAL_RAW_MATERIAL: 'ค่าตั้งต้นวัตถุดิบ/สินค้า',
          INITIAL_RAW_MATERIAL_FARM: 'ค่าตั้งต้นวัตถุดิบ/สินค้า (ฟาร์ม)',
        },
        SHAREHOLDER_SETTING: {
          TITLE: 'ตั้งค่าหุ้นส่วน(ปันผล)',
          SHAREHOLDER_INFORMATION: 'ข้อมูลสมาชิกภายใต้การจ่ายเงินปันผล',
          DIVIDEND_RATIOS: 'อัตราส่วนเงินปันผล',
        },
        POS_SETTING: {
          TITLE: 'ตั้งค่า POS',
          WAREHOUSE_SETTING: 'ตั้งค่าคลังสินค้า',
          TRANSFER_SETTING: 'การโอนสินค้าระหว่างคลัง',
          MENU_SETTING: 'ตั้งค่าสินค้า',
          CATEGORY_SETTING: 'ตั้งค่าหมวดหมู่สินค้า',
          ROUNDING_OFF_SETTING: 'ตั้งค่าการปัดเศษ',
          CANCELLATION_SETTING: 'ตั้งค่าเหตุผลการยกเลิก',
          PRINTER_SETTING: 'ตั้งค่าเครื่องปริ้น',
          POS_SETTING: 'ตั้งค่าเครื่องPOS',
          PROMOTION_SETTING: 'ตั้งค่าโปรโมชั่น',
        },
      },
    },

    LABEL_LIST: {
      NO_DATA: 'ไม่มีข้อมูล',
    },

    //Report
    INCOME_STATEMENT: {
      LIST: 'รายการ',
      AMOUNT_MONEY: 'รายได้',
      AMOUNT: 'จำนวนเงิน',
      INCOME: 'รายได้จากพันธุ์',
      INCOME_FOOD: 'รายได้จากอาหาร',
      INCOME_RAW_OTHER: 'รายได้จากวัตถุดิบอื่น',
      INCOME_PRODUCT: 'รายได้จากการขายผลผลิต',
      INCOME_OTHER: 'รายได้อื่น',
      INCOME_TOTAL: 'รวมรายได้',
      COST_OF_SALE: 'ต้นทุนขาย',
      COST: 'ต้นทุนพันธุ์',
      COST_FOOD: 'ต้นทุนอาหาร',
      COST_RAW_OTHER: 'ต้นทุนวัตถุดิบอื่น',
      COST_PRODUCT: 'ต้นทุนผลผลิต',
      COST_OTHER: 'ตุ้นทุนอื่น',
      COST_TOTAL: 'รวมต้นทุน',
      INITIAL_PROFIT: 'กำไร(ขาดทุน)ขั้นต้น',
      SELLING_ADMINISTER: 'ค่าใช้จ่ายในการขายและบริหาร',
      SELLING: 'ค่าใช้จ่ายในการขาย',
      ADMINISTER: 'ค่าใช้จ่ายในการบริหาร',
      OTHER_EXPENSE: 'ค่าใช้จ่ายอื่น',
      EXPENSE_TOTAL: 'รวมค่าใช้จ่าย',
      NET_PROFIT: 'กำไร(ขาดทุน)สุทธิ',
      CREDIT_DEBTOR: 'เงินเชื่อ(ลูกหนี้)',
      SALE_TAX: 'ภาษีขาย',
      TOTAL_CASH_FLOW: 'รวมกระแสเงินสดรับ',
      CASH_FLOW_RECEIVE: 'กระแสเงินสดรับ',
      CASH_FLOW_PAY: 'กระแสเงินสดจ่าย',
      RAW_PRODUCT: 'วัตถุดิบและสินค้า',
      PURCHASE_TAX: 'ภาษีซื้อ',
      EXPENSE: 'ค่าใช้จ่าย',
      SALARY: 'เงินเดือน',
      WAGES: 'ค่าแรง',
      CREDIT_CREDITOR: 'เงินเชื่อ(เจ้าหนี้)',
      TOTAL_CASH_FLOW_PAY: 'รวมกระแสเงินสดจ่าย',
      NET_CASH: 'เงินสดสุทธิ',
      INITIAL_INSTALLMENT_CASH: 'เงินสดต้นงวด',
      LAST_INSTALLMENT_CASH: 'เงินสดปลายงวด',
      PRODUCT: 'ผลผลิต',
      OTHER: 'อื่นๆ',
    },
    RECEIVE: {
      DATE: 'วันที่',
      DOC_NO: 'เลขที่ใบเสร็จ/เลขที่ใบแจ้งหนี้',
      PAYMENT_TYPE: 'ประเภทการชำระเงิน',
      PRICE_BEFORE_DISCOUNT: 'ราคารวมก่อนส่วนลด',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET: 'มูลค่าสุทธิ',
      STATUS: 'สถานะ',
      PRINT: 'พิมพ์ใบเสร็จ',
    },
    PURCHASE_TAX: {
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      NAME: 'ชื่อผู้จำหน่าย/ผู้ให้บริการ',
      CUSTOMER_NAME: 'ชื่อลูกค้า',
      TAX_NO: 'เลขประจำตัวผู้เสียภาษีอากรของผู้จำหน่าย',
      COMPANY: 'สถานประกอบการ',
      LOCATION: 'สถานที่',
      VALUE_BEFORE_VAT: 'มูลค่าก่อนภาษี',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      TOTAL: 'มูลค่ารวม',
      STATUS: 'สถานะ',
      DEALER: 'ผู้จำหน่าย',
      PAYMENT_TYPE: 'ช่องทางการชำระเงิน',
      TOTAL_BAHT: 'มูลค่ารวม (บาท)',
      TOTAL_CASH: 'เงินสดรวม(บาท)',
      TOTAL_CREDIT: 'เงินเชื่อรวม(บาท)',
      TOTAL_NET: 'รวมทั้งสิ้น(บาท)',
      DES: 'รายละเอียด',
      RAW: 'วัตถุดิบ',
      AMOUNT: 'จำนวน',
      UNIT: 'หน่วยนับ',
      MEMBER: 'สมาชิก',
      LOT: 'รุ่น',
      PRODUCT: 'ชื่อผลผลิต',
      UNIT_PRICE: 'ราคาต่อหน่วย (บาท)',
      CUSTOMER: 'ลูกค้า',
      RAW_MAT: 'วัตถุดิบ/ผลผลิต',
    },
    CONTRACT: {
      DATE: 'วันที่',
      CONTRACT_NO: 'หมายเลขสัญญา',
      CONTRACT_NAME: 'ชื่อสัญญา',
      PURCHASE_DIFF: 'ผลต่างยอดซื้อขายผ่านสัญญา (บาท)',
      NUM_OF_BREED: 'จำนวนรุ่นที่เลี้ยงในสัญญา (รุ่น)',
      SECURITY_DEPOSIT: 'เงินประกัน (บาท)',
      DESCRIPTION: 'รายละเอียด',
      CONTRACT: 'สัญญา',
      NAME_LOT: 'ชื่อรุ่น',
      INSURANCE: 'ราคาประกันผลผลิต (บาท)',
      INCOME: 'รายได้สุทธิ ของรุ่น (บาท)',
      STAUS: 'สถานะของรุ่น (เปิด/ปิด)',
      MAXIMUM: 'สูงสุด',
      MINIMUM: 'ต่ำสุด',
      UNIT: 'หน่วยนับ',
      SHOW: 'แสดงทั้งหมด',
      LOT: 'รุ่น',
      DATE_RAISING_PLANTINT: 'เริ่มเลี้ยง/ปลูก วันที่',
      RAW_RAISING_PLANTINT: 'เริ่มเลี้ยง/ปลูก วัตถุดิบตั้งต้น',
      AMOUNT: 'จำนวน',
      PRODUCT: 'ผลผลิต',
      START_DATE: 'วันที่เริ่มเลี้ยง',
      REARING_PLANTING_DURATION: 'ระยะเวลาการผลิต/ปลูก (วัน)',
      AMOUNT_PLAN: 'จำนวนเริ่มเลี้ยง/ปลูก (ตามแผน)',
      AMOUNT_TRUE: 'จำนวนเริ่มเลี้ยง/ปลูก (จริง)',
      LIST: 'รายการ',
      PLAN_REARING: 'จำนวนวันที่เลี้ยงตามแผน',
      AMOUNT_RAW_REMAIN: 'จำนวนวัตถุดิบตั้งต้นคงเหลือ (ตัว, ต้น)',
      AMOUNT_FOOD_REQUIRED: 'ปริมาณต้องให้อาหารต่อวัน (กก.)',
      REQUIRED: 'ต้องใช้อาหารทั้งสิ้น (กก.)',
      AMOUNT_REARING: 'จำนวนวันที่เลี้ยงมาแล้ว (วัน)',
      ADD_FOOD: 'อาหารที่ต้องใช้เพิ่มเติม (กก.)',
      PREDICT_PRODUCT: 'คาดการณ์ผลผลิต (กก.)',
      DATE_KEEP_PRODUCT: 'วันที่จะเก็บผลผลิตได้',
      NAME_ACTIVITY: 'ชื่อกิจกรรม',
      AMOUNT_DEFAULT: 'จำนวนวัตถุดิบตั้งต้น',
      DEAD: 'อัตราการตาย (%)',
      SURVIVE: 'อัตราการรอด (%)',
      GROWTH: 'อัตราการเจริญเติบโต (%)',
      TEST: 'อัตราการแลกเนื้อ (%)',
      WEIGHT: 'น้ำหนักโดยเฉลี่ย',
      AMOUNT_FOOD: 'ปริมาณอาหารที่ใช้ต่อตัว',
      TYPE: 'ชนิด',
      DATE_PRODUCT: 'วันที่เริ่มให้ผลผลิต',
      HARVEST_DARTE: 'วันที่เก็บเกี่ยว',
    },
    PURCHASE_REPORT: {
      LIST: 'รายการ',
      AMOUNT_REMAIN: 'ปริมาณคงเหลือ',
      AMOUNT_PER_DAY: 'ปริมาณการใช้ต่อวัน',
      AMOUNT_DATE: 'จำนวนวันที่ใช้ได้',
      TO: 'ใช้ได้ถึงวันที่',
      ORDER_BEFORE_DATE: 'สั่งก่อนวันที่',
    },
    TRANPORT_REPORT: {
      SALES_DATE: 'วันที่ขาย',
      DOC_NO_DELIVERY: 'เลขที่ใบส่งสินค้า',
      DOC_NO_BILL: 'เลขที่ใบเสร็จ/เลขที่ใบแจ้งหนี้',
      DELIVERY_DATE: 'วันที่ส่งสินค้า',
      CUSTOMER_NAME: 'ชื่อลูกค้า',
      ADDRESS: 'ที่อยู่ลูกค้า',
      LOCATION: 'สถานที่ส่งสินค้า',

      MONTH: 'เดือน',
      START_DATE: 'วันที่',
      LIST: 'ชื่อวัตถุดิบ',
      DOC_NO: 'เลขที่เอกสาร',
      AMOUNT: 'จำนวน',
      UNIT: 'หน่วยนับ',
      EXPIRATION_DATE: 'วันที่หมดอายุ',

      DATE: 'เริ่มนับวัน/เดือน/ปี',
      AMOUNT_DAY: 'จำนวนวัน',
      REF: 'อ้างอิงปริมาณการขายปีก่อนหน้า',
      PLAN_SALES: 'แผนการขาย',
      ADJUST: 'ปรับเพิ่ม',
      TOTAL: 'รวมขาย',
      REF_LAST_YEAR: 'อ้างอิงการขายปีก่อนหน้า',
      PLAN_SALES_DAY: 'แผนการขาย (กก./วัน)',
      ADJUST_DAY: 'ปรับเพิ่ม (กก./วัน)',
      TOTAL_KG: 'รวมขาย (กก.)',
      NET_DELIVERY: 'มูลค่าสุทธิของใบส่งของ',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      DELIVERY_NET: 'มูลค่าสุทธิของใบส่งของ',
      SV: '%SV (อัตราการรอด)',
      AMOUNT_REARING: 'จำนวนต้องเลี้ยง',
      AVERAGE: 'ระยะเวลาการผลิตโดยเฉลี่ย',
      START: 'เริ่มเลี้ยงโดยประมาณ (วันที่)',
      PHONE: 'เบอร์โทรศัพท์',
      STATUS: 'สถานะการส่งมอบ',
      DETAIL: 'รายละเอียด',
    },
    CASH_FLOW: {
      BEGIN_CASH: 'เงินสดต้นงวด',
      AMOUNT: 'จำนวนเงิน (บาท)',
      RECEIVE_CASH: 'เงินสดรับ',
      RECEIVE_CASH_SALE: 'เงินสดรับจากการขายสด',
      RECEIVE_CASH_DEBTOR: 'เงินสดรับจากการเรียกเก็บจากลูกหนี้',
      PAY_CASH: 'เงินสดจ่าย',
      PAY_CASH_PURCHASE: 'เงินสดจ่ายค่าซื้อวัตถุดิบ/สินค้า',
      PAY_CASH_BUY: 'เงินสดจ่ายรับซื้อผลผลิต',
      PAY_CASH_CREDITOR: 'เงินสดจ่ายเงินเชื่อ(เจ้าหนี้)',
      PAY_CASH_EXPENSE: 'เงินสดจ่ายค่าใช้จ่าย',
      PAY_CASH_SALARY: 'เงินสดจ่ายเงินเดือน',
      PAY_CASH_WAGE: 'เงินสดจ่ายค่าแรงจ้างเหมา',
      PAY_CASH_NET: 'รวมเงินสดจ่ายสุทธิ',
      PAY_CASH_LAST: 'เงินสดปลายงวด',
      DATE_RECEIVE_MONEY: 'ประมาณการวันรับเงิน(ลูกหนี้ ) - จ่ายเงิน(เจ้าหนี้)',
      CREDIT_TERM: 'กลุ่มวันเครดิตเทอม',
      TERM: 'เครดิตเทอม',
      DAY: 'วัน',
      TERM_30: 'เครดิตเทอม 30 วัน',
      CREDIT_NOT_RECEIVE: 'เงินเชื่อที่ยังไม่ได้รับ (ลูกหนี้)',
      CREDIT_NOT_RECEIVE_CREDITOR: 'เงินเชื่อที่ยังไม่ได้จ่าย (เจ้าหนี้)',
      DATE_TO_SALES: 'วันที่ขาย',
      REMAIN_RECEIVE: 'คงเหลือค้างรับ',
      DUE_DATE: 'วันครบกำหนด',
      DATE_TO_PURCHASER: 'วันที่ซื้อ',
      REMAIN_PAY: 'คงเหลือค้างจ่าย',
    },

    //Member information
    FARM_INFORMATION: {
      TITLE: 'ข้อมูลฟาร์ม',
      CREATE_FARM: 'สร้างฟาร์ม',
      EDIT_FARM: 'แก้ไขฟาร์ม',
      TITLE_LIST: 'รายชื่อฟาร์ม',
      OWNER: 'เจ้าของฟาร์ม',
      NAME_LIST: 'ชื่อฟาร์ม',
      PHONE: 'เบอร์โทรศัพท์',
      FARM_NAME: 'หมายเลขสมาชิก',
      REGIS_ID: 'เลขทะเบียน',
      OGANIZATION: 'ชื่อองค์กร',
      NAME: 'ชื่อ',
      LAST_NAME: 'สกุล',
      CARD_ID: 'เลขประจำตัวประชาชน',
      CARD_END_DATE: 'วันหมดอายุบัตร',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      EMAIL: 'อีเมล',
      FAX: 'แฟกส์',
      LAT: 'ละติจูด',
      LONG: 'ลองติจูด',
      COORDINATES: 'พิกัดฟาร์ม',
      CLAY_SET: 'ชุดดิน',
      MINERAL_CONTENT: 'ปริมาณแร่ธาตุ',
      NPK: 'NPK',
      PLOT_SIZE: 'ขนาดแปลง',
      PLOT_PICTURE: 'รูปแปลง',
      PLOT_NAME: 'ชื่อแปลง',
      USERNAME: 'บัญชีผู้ใช้',
      PASSWORD: 'รหัสผ่าน',
      CON_PASSWORD: 'ยืนยันรหัสผ่าน',
      CREDIT: 'เครดิตเทอม (วัน)',
      AREA_ALL: 'พื้นที่ทั้งหมด',
      REMAIN_AREA: 'พื้นที่คงเหลือ',
    },
    AGENT_INFORMATION: {
      TITLE: 'ข้อมูลตัวกลาง',
      CREATE: 'สร้างสมาชิก',
      CREATE_MEMBER: 'สร้างพนักงานให้',
      CREATE_AGENT: 'สร้างตัวกลาง',
      EDIT_AGENT: 'แก้ไขตัวกลาง',
      TITLE_LIST: 'รายชื่อสมาชิก',
      NAME_LIST: 'ชื่อตัวกลาง',
      PHONE: 'เบอร์โทรศัพท์',
      FARM_NAME: 'หมายเลขสมาชิก',
      REGIS_ID: 'เลขทะเบียน',
      OGANIZATION: 'ชื่อองค์กร',
      NAME: 'ชื่อ',
      LAST_NAME: 'สกุล',
      CARD_ID: 'เลขประจำตัวประชาชน',
      CARD_END_DATE: 'วันหมดอายุบัตร',
      TYPE_CONTRACT: 'ประเภทฟาร์ม',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      EMAIL: 'อีเมล',
      FAX: 'แฟกส์',
      LAT: 'ละติจูด',
      LONG: 'ลองติจูด',
      USERNAME: 'บัญชีผู้ใช้',
      PASSWORD: 'รหัสผ่าน',
      CON_PASSWORD: 'ยืนยันรหัสผ่าน',
      TYPE_SYSTEM_ACCOUNT: 'ประเภทสมาชิก',
    },
    MESSAGING: {
      TITLE: 'แจ้งข้อความสมาชิก',
      TITLE_FARM: 'ข้อความแจ้งจากตัวกลาง',
      CREATE: 'สร้างแจ้งข้อความสมาชิก',
      EDIT: 'แก้ไขแจ้งข้อความสมาชิก',
      TITLE_MESSAGING: 'กล่องข้อความ',
      CREATE_MESSAGING: 'สร้างข้อความ',
      EDIT_MESSAGING: 'ตอบกลับข้อความ',
      DATE: 'วันที่',
      TIME: 'เวลา',
      MESSAGING: 'ข้อความ',
      HEADER: 'หัวเรื่อง',
      MEMBER: 'สมาชิก',
      MEMBER_ALL: 'เลือกสมาชิกทั้งหมด',
      RECEIVE: 'ผู้รับ',
      SENDING: 'ผู้ส่ง',
      FROM: 'จาก',
      TO: 'ถึง',
    },

    //Raw Material
    PRE_ORDER: {
      TITLE_LIST: 'รายการสั่งซื้อวัตถุดิบ / สินค้า',
      CREATE_PURCHASE: 'สร้างใบสั่งซื้อวัตถุดิบ / สินค้า',
      SHOW_PURCHASE: 'สั่งซื้อวัตถุดิบ / สินค้า',
      DATE: 'วันที่เอกสาร',
      DOC_NO: 'เลขที่เอกสาร',
      IS_CREATE_AUTO: 'สร้างใบรับเข้าอัตโนมัติ',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่ผู้จำหน่าย',
      PAYMENT: 'ช่องทางการชำระ',
      STATUS_DOC: 'สถานะเอกสาร',
      STATUS_PAYMENT: 'สถานะการชำระ',
      TITLE: 'บันทึกใบสั่งซื้อวัตถุดิบ / สินค้า',
      READ_FROM: 'อ่านจาก',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      PICK_UP_DATE: 'วันที่รับสินค้า',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      DISCOUNT: 'ส่วนลด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      LIST_RAW_MATERIAL: 'รายการสั่งซื้อวัตถุดิบ/สินค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      AMOUNT_RECEIVE: 'จำนวนที่รับแล้ว',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      NUMBER: 'ลำดับ',
      DEADLINE_DATE: 'วันที่กำหนดส่ง',
      DELIVERY_ADDRESS: 'ที่อยู่จัดส่งสินค้า',
      UNIT_DISCOUNT: 'หน่วยส่วนลด',
    },
    PURCHASE_ORDER: {
      TITLE_LIST: 'รายการซื้อวัตถุดิบ / สินค้า',
      CREATE_PURCHASE: 'บันทึกซื้อวัตถุดิบ / สินค้า',
      SHOW_PURCHASE: 'ใบซื้อวัตถุดิบ / สินค้า',
      DATE: 'วันที่',
      AMOUNT_EX_DATE: 'จำนวนวันหมดอายุ',
      DOC_NO: 'เลขที่เอกสาร',
      IS_CREATE_AUTO: 'สร้างใบรับเข้าอัตโนมัติ',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่ผู้จำหน่าย',
      PAYMENT: 'ช่องทางการชำระ',
      STATUS_DOC: 'สถานะเอกสาร',
      STATUS_PAYMENT: 'สถานะการชำระ',
      TITLE: 'บันทึกซื้อวัตถุดิบ / สินค้า',
      READ_FROM: 'อ่านจาก',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      PICK_UP_DATE: 'วันที่รับสินค้า',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ซื้อ',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      DISCOUNT: 'ส่วนลด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      LIST_RAW_MATERIAL: 'รายการซื้อวัตถุดิบ/สินค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      AMOUNT_RECEIVE: 'จำนวนที่รับแล้ว',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      STATUS: 'สถานะการส่งมอบ',
      EX_DATE: 'วันที่หมดอายุ',
      UNIT_DISCOUNT: 'หน่วยส่วนลด',
    },
    RAW_MATERIAL_RECEIVING: {
      TITLE_LIST: 'รายการรับเข้าวัตถุดิบ/สินค้า',
      CREATE_RECEIVING: 'บันทึกรับเข้าวัตถุดิบ/สินค้า',
      SHOW_RECEIVING: 'ใบรับเข้าวัตถุดิบ/สินค้า',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      DOC_PURCHASES: 'เลขที่ใบซื้อ',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่',
      PAYMENT: 'ช่องทางการชำระ',
      STATUS: 'สถานะ',
      TITLE: 'บันทึกรับเข้าวัตถุดิบ / สินค้า',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      READ_FROM: 'อ่านจาก',
      PURCHASE_ORDER: 'ใบซื้อวัตถุดิบ',
      CLAIM_ORDER: 'ใบเคลม',
      DOC_NO_DATE: 'วันที่เอกสาร',
      RECEIV_DATE: 'วันที่รับเข้า',
      LIST_RAW_MATERIAL_RECEIVING: 'รายการรับเข้าวัตถุดิบ/สินค้า',
      NOTE: 'หมายเหตุ',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวนที่รับ',
      REMAIN: 'จำนวนที่เหลือ',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวมมูลค่า',
      HAS_VAT: 'มีภาษี',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      TOTAL: 'รวมทั้งหมด',
      IS_CLAIM: 'เลือกรายการรับเคลม',
      BALANCE: 'คงเหลือ',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
    },
    RAW_MATERIAL_REQUISITION: {
      TITLE_LIST: 'รายการเบิก',
      CREATE_REQUISITION: 'สร้างรายการเบิก',
      SHOW_REQUISITION: 'รายการเบิก',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      DOC_NO_DATE: 'วันที่เอกสาร',
      PICK_UP: 'ผู้เบิก',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      STATUS: 'สถานะ',
      PICK_UP_OPERATOR: 'ผู้ดำเนินการเบิก',
      TITLE: 'บันทึกรายการเบิกวัตถุดิบ',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT_STOCK: 'จำนวน',
      AMOUNT: 'จำนวนที่เบิก',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      TOTAL: 'รวมทั้งหมด',
      NOTE: 'หมายเหตุ',
      LIST_RAW_MATERIAL_REQUISITION: 'รายการเบิกวัตถุดิบ/สินค้า',
      MEMBER: 'สมาชิก',
      UNIT_MAIN: 'หน่วยหลัก',
    },
    RAW_MATERIAL_CLAIM: {
      TITLE_LIST: 'รายการเคลมวัตถุดิบ/สินค้า',
      CREATE_CLAIM: 'สร้างใบเคลมวัตถุดิบ/สินค้า',
      SHOW_CLAIM: 'ใบเคลมวัตถุดิบ/สินค้า',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่',
      STATUS: 'สถานะ',
      READ_FROM: 'อ่านจาก',
      DOC_NO_DATE: 'วันที่เอกสาร',
      PURCHASE: 'ใบซื้อวัตถุดิบ',
      TITLE: 'บันทึกรายการเคลมวัตถุดิบ',
      LIST_RAW_MATERIAL_CLAIM: 'รายการที่ส่งเคลมวัตถุดิบ/สินค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวนที่เคลม',
      RECEIVE_AMOUNT: 'จำนวนที่รับเข้า',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DURATION: 'ระยะเวลา (วัน)',
      IS_CLAIM: 'เคลม',
      NOTE: 'หมายเหตุ',
      TOTAL: 'รวมทั้งหมด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
    },
    RETURN_ORDER: {
      TITLE_LIST: 'รายการส่งเคลม/ส่งคืน',
      CREATE_CLAIM: 'ส่งเคลม/ส่งคืน',
      SHOW_CLAIM: 'ใบส่งเคลม/คืน',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่',
      STATUS: 'สถานะ',
      READ_FROM: 'อ่านจาก',
      DOC_NO_DATE: 'วันที่เอกสาร',
      PURCHASE: 'ใบซื้อวัตถุดิบ',
      TITLE: 'บันทึกรายการส่งคืน',
      LIST_RETURN_ORDER: 'รายการส่งเคลม/ส่งคืน',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวนส่งเคลม-คืน',
      RECEIVE_AMOUNT: 'จำนวนที่รับเข้า',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DURATION: 'ระยะเวลา (วัน)',
      IS_CLAIM: 'ส่งเคลม-คืน',
      NOTE: 'หมายเหตุ',
      TOTAL: 'รวมทั้งหมด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      SYSTEM_ACCOUNT: 'ซื้อจากสมาชิก',
      RAW_MATERAIL_PUCHASES: 'ใบซื้อวัตถุดิบ/สินค้า',
      SEND_OR_CLAIM: 'ส่งเคลมหรือส่งคืน',
    },
    RAW_MATERIAL_RETURN: {
      TITLE_LIST: 'รายการคืนวัตถุดิบ/สินค้า',
      CREATE_RETURN: 'สร้างรายการคืนวัตถุดิบ/สินค้า',
      SHOW_RETURN: 'รายการคืนวัตถุดิบ/สินค้า',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      DEALER: 'ผู้จำหน่าย',
      ADDRESS: 'ที่อยู่',
      STATUS: 'สถานะ',
      READ_FROM: 'อ่านจาก',
      DOC_NO_DATE: 'วันที่เอกสาร',
      PURCHASE: 'ใบซื้อวัตถุดิบ',
      TITLE: 'บันทึกรายการคืนวัตถุดิบ',
      LIST_RAW_MATERIAL_RETURN: 'รายการที่ส่งคืนวัตถุดิบ/สินค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      RECEIVE_AMOUNT: 'จำนวนที่เหลือ',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      IS_RETURN: 'คืน',
      NOTE: 'หมายเหตุ',
      TOTAL: 'รวมทั้งหมด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
    },
    STOCK_ADJUST: {
      TITLE_LIST: 'รายการปรับปรุงสต๊อก',
      CREATE_STOCK_ADJUST: 'บันทึกปรับปรุงสต๊อก',
      SHOW_STOCK_ADJUST: 'รายการปรับปรุงสต๊อก',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      STATUS: 'สถานะ',
      DOC_NO_DATE: 'วันที่เอกสาร',
      TITLE: 'ปรับปรุงสต็อก',
      LIST_STOCK_ADJUSTt: 'รายการปรับปรุงสต๊อก',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวนในระบบ',
      VALUE: 'มูลค่าในระบบ',
      CURENT_AMOUNT: 'จำนวนนับจริง',
      CURENT_VALUE: 'มูลค่านับจริง',
      DESCRIPTION: 'คำอธิบาย',
      NET_WORTH: 'มูลค่าสุทธิ',
      STOCK: 'คลังสินค้า',
      UNIT_MAIN: 'หน่วยหลัก',
    },
    RAW_MATERIAL_BID: {
      TITLE_LIST: 'รายการใบเสนอราคาวัตถุดิบ/ผลผลิต/สินค้า',
      SHOW: 'ใบเสนอราคาวัตถุดิบ/ผลผลิต/สินค้า',
      DATE: 'วันที่เอกสาร',
      AMOUNT_EX_DATE: 'วันหมดอายุเอกสาร',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'สร้างใบเสนอราคาวัตถุดิบ/ผลผลิต/สินค้า',
      READ_FROM: 'อ่านจาก',
      IS_SELL: 'เสนอให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      SALE_PERSON: 'พนักงานเสนอราคา',
      LIST_RAW_MATERIAL: 'รายการเสนอราคาวัตถุดิบ/ผลผลิต/สินค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการเสนอราคา',
      FILED_DATE: 'ยื่นราคาภายในวัน',
      CREDIT_DATE: 'จำนวนวันเครดิต',
      DEADLINE_DATE: 'วันที่กำหนดส่ง',
      ADDRESS: 'ที่อยู่',
      TEL: 'เบอร์โทร',
      UNIT_DISCOUNT: 'หน่วยส่วนลด',
    },
    RAW_MATERIAL_SELL: {
      TITLE_LIST: 'รายการขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
      TITLE_LIST_POS: 'รายการขายจาก POS',
      SHOW: 'ขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกการขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
      READ_FROM: 'อ่านจาก',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      SENT_DATE: 'วันที่ส่งของ',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      READ_FROM_DEPOSIT: 'อ่านจากเงินมัดจำ',
      DEPOSIT: 'เงินมัดจำ',
      VALUE_DEPOSIT: 'หักเงินมัดจำรวม',
      VALUE_AFTER_DEPOSIT: 'มูลค่าหลังหักเงินมัดจำ',
      UNIT_DISCOUNT: 'หน่วยส่วนลด',
    },
    RAW_MATERIAL_BUY: {
      TITLE_HAVEST_LIST: 'รายการเก็บเกี่ยว',
      CONTRACT_FARM: 'สัญญาเกษตรกร',
      PRODUCT: 'ผลผลิต',
      HAVEST_DATE: 'วันที่เก็บเกี่ยว',
      TITLE_LIST: 'รายการรับซื้อ',
      DATE: 'วันที่เอกสาร',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      DOC_NO: 'เลขที่เอกสาร',
      CONTRACT: 'สัญญา',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      PRODUCT_INFORMATION: 'ข้อมูลผลผลิตในแต่ละรุ่น',
      LIST_HAVEST: 'รายการบันทึกการเก็บเกี่ยวผลผลิต',
      LOT: 'รุ่น',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT_RAW: 'จำนวนผลผลิต',
      AMOUNT: 'ที่รับซื้อ',
      AMOUNT1: 'รับซื้อแล้ว',
      VALUE: 'มูลค่า',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      TITLE_HAVEST: 'บันทึกการเก็บเกี่ยว',
      TITLE: 'บันทึกการรับซื้อผลผลิต',
      SHOW_PURCHASE: 'รับซื้อผลผลิต',
      RECEIVING_MONEY_TYPE: 'ประเภทรับเงิน',
      LIST_BUY: 'รายการบันทึกการรับซื้อผลผลิต',
    },
    RAW_MATERIAL_DEPOSIT: {
      TITLE_LIST: 'รายการเงินมัดจำ',
      SHOW: 'มัดจำ',
      DATE: 'วันที่เอกสาร',
      TEL: 'เบอร์โทร',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกเงินมัดจำ',
      READ_FROM: 'อ่านจาก',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่มัดจำ',
      RECEIVE_DATE: 'วันรับสินค้า',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการเงินมัดจำ',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      PRICE_AFTER_DEPOSIT: 'ราคาหลังหักเงินมัดจำ',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'จำนวนเงินรวมทั้งสิ้น',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      QUOTATION: 'ใบเสนอราคา',
      DEPOSIT: 'เงินมัดจำ',
      TOTAL_DEPOSIT: 'รวมเงินมัดจำ',
      UNIT_DEPOSIT: 'หน่วยนับมัดจำ',
    },
    RAW_MATERIAL_RECEIVE_CLAIM: {
      TITLE_LIST: 'รายการรับเคลม/รับคืน',
      SHOW: 'รับเคลมคืน',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกรับเคลม/รับคืน',
      READ_FROM: 'อ่านจากใบขาย',
      IS_SELL: 'สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่เอกสาร',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการรับเคลม/รับคืน',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      RECEIVE_OR_CLAIM: 'รับเคลมหรือรับคืน',
      SEND_OR_CLAIM: 'ส่งเคลมหรือส่งคืน',
      CUSTOMER_OR_MEMBER: 'ลูกค้าหรือสมาชิก ',
      RECEIVE_AMOUNT: 'จำนวนรับเคลม-คืน',
      DURATION: 'ระยะเวลา (วัน)',
      IS_CLAIM: 'รับเคลม-คืน',
      IS_STOCK: 'คืนสต๊อก',
    },

    RAW_MATERIAL_SEND_CLAIM: {
      TITLE_LIST: 'รายการส่งสินค้าที่เคลมให้ลูกค้า',
      SHOW: 'ส่งเคลมคืนให้ลูกค้า',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกส่งสินค้าที่เคลมให้ลูกค้า',
      READ_FROM: 'อ่านจาก',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ส่งสินค้าเคลม',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการส่งสินค้าที่เคลมให้ลูกค้า',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      CLAIM_AMOUNT: 'จำนวนที่เคลม',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      RECEIVED_CLAIM: 'ใบรับเคลม',
      UNIT_DISCOUNT: 'หน่วยส่วนลด',
    },

    REDUCE_DEBT: {
      TITLE_LIST: 'รายการลดหนี้',
      SHOW: 'ลดหนี้',
      DATE: 'วันที่เอกสาร',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกการลดหนี้',
      READ_FROM: 'อ่านจากใบขาย',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการลดหนี้',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมเป็นเงิน',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      VALUE_OLD: 'มูลค่าตามเอกสารเดิม',
      VALUE_NEW: 'มูลค่าที่ถูกต้อง',
      DIFFERENCE: 'ผลต่าง',
      RECEIVED_CLAIM: 'อ่านจากใบรับเคลม/รับคืน',
      ADDRESS: 'ที่อยู่',
      ORIGINAL_DOC_NO: 'เลขที่ใบกำกับเดิม',
      SEND_CLAIM: 'อ่านจากใบรับคืน',
      CAUSE: 'สาเหตุ',
      DIFFERENCE_ALL: 'ผลต่างรวม',
      CUSTOMER_MEMBER: 'ลูกค้า/สมาชิก',
    },

    ADD_DEBT: {
      TITLE_LIST: 'รายการเพิ่มหนี้',
      SHOW: 'เพิ่มหนี้',
      DATE: 'วันที่เอกสาร',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกการเพิ่มหนี้',
      READ_FROM: 'อ่านจากใบขาย',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการเพิ่มหนี้',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมเป็นเงิน',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      VALUE_OLD: 'มูลค่าตามเอกสารเดิม',
      VALUE_NEW: 'มูลค่าที่ถูกต้อง',
      DIFFERENCE: 'ผลต่าง',
      RETURN_CLAIM: 'ใบส่งสินค้าที่เคลมให้ลูกค้า',
      RECEIVED_CLAIM: 'อ่านจากใบรับเคลม',
      ADDRESS: 'ที่อยู่',
      ORIGINAL_DOC_NO: 'เลขที่ใบกำกับเดิม',
      SEND_CLAIM: 'อ่านจากใบรับคืน',
      CAUSE: 'สาเหตุ',
      DIFFERENCE_ALL: 'ผลต่างรวม',
      CUSTOMER_MEMBER: 'ลูกค้า/สมาชิก',
    },

    SEND_ORDER: {
      TITLE_LIST: 'รายการส่งของ',
      SHOW: 'ส่งของ',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_TYPE: 'ประเภทการชำระ',
      STATUS: 'สถานะ',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      TITLE: 'บันทึกการส่งของ',
      READ_FROM: 'อ่านจาก',
      IS_SELL: 'ขายให้สมาชิก',
      CUSTOMER: 'ลูกค้า',
      MEMBER: 'สมาชิก',
      PAYMENT_DATE: 'วันที่ชำระเงิน/วันที่ขาย',
      SALE_PERSON: 'พนักงานขาย',
      LIST_RAW_MATERIAL: 'รายการส่งของ',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_LIST: 'รวม',
      DISCOUNT: 'ส่วนลด',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      IS_VAT: 'มีภาษี',
      NOTE: 'หมายเหตุ',
      NO_TAX: 'ไม่มีภาษี',
      TAX: 'มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TOTAL_TABLE: 'รวมทั้งหมด',
      SALE_TYPE: 'ประเภทการขาย',
      DELIVERY_DATE: 'วันส่งของ',
      DUE_DATE: 'กำหนดส่ง',
    },

    REPORT: {
      TITLE: 'รายงาน',
      WAREHOUSE_REPORT: {
        TITLE: 'รายงานคลังสินค้า',
        INVENTORY_REPORT: 'รายงานสินค้าคงเหลือ',
        INVENTORY: 'สินค้าคงเหลือ',
        INVENTORY_POS: 'สินค้าคงเหลือ POS',
        CLAIM_RECEIVE_REPORT: 'รายงานส่งเคลม/ส่งคืน',
        CHOOSE_CLAIM_RECEIVE: 'เลือกเคลม/รับเคลม',
        CLAIM_RECEIVE: 'เคลม/รับเคลม',
        REPORT_BACK: 'รายงานรับเคลม/รับคืน',
        DATE: 'วันที่',
        CONTRACT_NAME: 'ชื่อผู้ติดต่อ',
        STATUS: 'สถานะ',
        DETAIL: 'รายละเอียด',
        SEE_DETAIL: 'ดูรายละเอียด',
        RAW_MATERIAL_LIST: 'รายการวัตถุดิบ',
        AMOUNT: 'จำนวน',
        UNIT: 'หน่วยนับ',
        CLAIM_PERIOD: 'ระยะเวลาการส่งเคลม (วัน)',
        TYPE: 'ประเภท',
        CHOOSE_TYPE: 'เลือกประเภท',
        LIST: 'รายการ',
        AMOUNT_IMPORTS: 'จำนวนนำเข้า',
        VALUE_BAHT: 'มูลค่า (บาท)',
        REMAIN: 'คงเหลือ',
      },
    },

    //Account Setting
    EXPENSES: {
      TITLE: 'รายการค่าใช้จ่าย',
      ADD_EXPENSES: 'บันทึกค่าใช้จ่าย',
      EDIT_EXPENSES: 'แก้ไขค่าใช้จ่าย',
      DATE: 'วันที่',
      DOC_NO: 'เลขที่เอกสาร',
      DEALER: 'ผู้จำหน่าย',
      PAYMENT: 'ช่องทางการชำระ',
      NET_WORTH_BAHT: 'มูลค่าสุทธิ(บาท)',
      STATUS: 'สถานะ',
      DOC_NO_DATE: 'วันที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      READ_FROM: 'อ่านจาก',
      LIST: 'รายการ',
      DISCOUNT: 'ส่วนลด',
      VALUE: 'มูลค่า',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TOTAL: 'รวมทั้งหมด',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      NOTE: 'หมายเหตุ',
      UNIT: 'หน่วย',
      CHOOSE_DEALER: 'เลือกผู้จำหน่าย',
      VALUE_BEFORE_DISCOUNT: 'มูลค่าก่อนหักส่วนลด',
      VALUE_TOTAL: 'มูลค่ารวม',
      DISCOUNT_UNIT: 'หน่วยส่วนลด',
    },

    ACCEPT_DEBT: {
      TITLE: 'รายการรับชำระหนี้',
      ADD_ACCEPT_DEBT: 'บันทึกรับชำระหนี้',
      EDIT_ACCEPT_DEBT: 'แก้ไขรับชำระหนี้',
      DATE: 'วันที่',
      DEBTOR_NAME: 'ชื่อลูกหนี้',
      DEBTOR_CODE: 'รหัสลูกหนี้',
      GET_PAID: 'ยอดรับชำระ',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_METHOD: 'ช่องทางการชำระ',
      STATUS: 'สถานะ',
      DOC_NO_DATE: 'วันที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      READ_FROM: 'อ่านจาก',
      RAW_MATERAIL_SALE: 'ใบขายวัตถุดิบ/ผลผลิต/อุปกรณ์',
      OTHER_INCOME: 'ใบรายได้อื่นๆ',
      POS_RECEIVE: 'ใบขาย POS',
      DEBTOR: 'ลูกหนี้',
      DEBTOR_TYPE: 'ประเภทลูกหนี้',
      AMOUNT: 'จำนวนเงินที่ชำระ',
      OVERDUE: 'ยอดค้างชำระ',
      REMAIN: 'คงเหลือ',
      PAYMENT: 'การชำระ',
      NOTE: 'หมายเหตุ',
      INVOICE_NUMBER: 'เลขที่ใบแจ้งหนี้',
      SALE_DATE: 'วันที่ขาย',
      DETAIL: 'รายละเอียด',
      CREDIT_TERM: 'เครดิตเทอม (วัน)',
      DUE_DATE: 'วันครบกำหนดชำระ',
      UNPAID_AMOUNT: 'จำนวนค้างชำระ',
      PAYMENT_DATE: 'วันที่รับชำระ',
      INSTAILLMENT: 'งวดที่',
      RECEIVED_AMOUNT: 'จำนวนเงินที่รับชำระ',
      OUTSTANDUNG_BALANCE: 'คงเหลือค้างรับ',
      CHOOSE_DEBTOR: 'เลือกลูกหนี้',
      CHOOSE_DEBTOR_TYPE: 'เลือกประเภทลูกหนี้',
      CUSTOMER: 'ลูกค้า',
      CHOOSE_CUSTOMER: 'เลือกลูกค้า',
      LIST: 'แสดงรายการ',
      LIST_OVERDUE: 'เฉพาะรายการที่ค้างรับชำระ',
      DEBT: '-ลดหนี้/+เพิ่มหนี้',
      CUSTOMER_NAME: 'ชื่อลูกค้า',
      CUSTOMER_CODE: 'รหัสลูกค้า',
      DEBTOR_INFO: 'ข้อมูลลูกหนี้',
      MEMBER_CODE: 'รหัสสมาชิก',
      MEMBER_NAME: 'ชื่อสมาชิก',
      ADDRESS: 'ที่อยู่ปัจจุบัน',
      PHONE: 'เบอร์โทรศัพท์',
      EMAIL: 'อีเมล',
      NO: 'เลขบัตรประจำตัวประชาชน',
      CREDIT: 'เครดิตเทอม',
    },

    PAY_OFF_DEBT: {
      TITLE: 'รายการจ่ายชำระหนี้',
      ADD_PAY_OFF_DEBT: 'บันทึกจ่ายชำระหนี้',
      EDIT_PAY_OFF_DEBT: 'แก้ไขจ่ายชำระหนี้',
      DATE: 'วันที่',
      DATE_PAY_OFF: 'วันที่จ่ายชำระ',
      CREDITOR_NAME: 'ชื่อเจ้าหนี้',
      GET_PAID: 'ยอดรับชำระ',
      DOC_NO: 'เลขที่เอกสาร',
      PAYMENT_METHOD: 'ช่องทางการชำระ',
      STATUS: 'สถานะ',
      DOC_NO_DATE: 'วันที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      READ_FROM: 'อ่านจาก',
      RAW_MATERAIL_PUCHASES: 'ใบซื้อวัตถุดิบ/สินค้า',
      RAW_MATERAIL_PUCHASES_PRODUCT: 'ใบรับซื้อวัตถุดิบ/สินค้า',
      RAW_MATERAIL_RECEIVE: 'ใบรับเข้าวัตถุดิบ/สินค้า',
      EXPENSE: 'ใบค่าใช้จ่าย',
      CREDITOR: 'เจ้าหนี้',
      AMOUNT: 'จำนวนเงินที่ชำระ',
      OVERDUE: 'ยอดค้างชำระ',
      TIMES: 'งวดที่',
      REMAIN: 'คงเหลือ',
      PAYMENT: 'การชำระ',
      REF_NO_DOC: 'เอกสารอ้างอิง',
      NOTE: 'หมายเหตุ',
      SHOW_LIST: 'แสดงรายการ',
      VENDOR_CODE: 'รหัสผู้จำหน่าย',
      DETAIL: 'รายละเอียด',
      CREDIT_TERM: 'เครดิตเทอม (วัน)',
      DUE_DATE: 'วันครบกำหนดชำระ',
      UNPAID_AMOUNT: 'จำนวนค้างชำระ',
      PAYMENT_DATE: 'วันที่รับชำระ',
      INSTAILLMENT: 'งวดที่',
      PAYMENT_AMOUNT: 'จำนวนเงินที่จ่ายชำระ',
      OUTSTANDUNG_BALANCE: 'คงเหลือค้างชำระ',
      CHOOSE_LIST: 'เลือกรายการ',
      DEALER: 'ผู้จำหน่าย',
      CHOOSE_DEALER: 'เลือกผู้จำหน่าย',
      LIST_BALANCE: 'เฉพาะยอดคงเหลือค้างจ่าย',
      RETURN: 'ส่งคืน',
      DEALER_NAME: 'ชื่อผู้จำหน่าย',
      DEALER_CODE: 'รหัสผู้จำหน่าย',
      DEALER_INFO: 'ข้อมูลผู้จำหน่าย',
      ADDRESS: 'ที่อยู่ปัจจุบัน',
      PHONE: 'เบอร์โทรศัพท์',
      EMAIL: 'อีเมล',
      NO: 'เลขประจำตัวผู้เสียภาษี',
      CREDIT: 'เครดิตเทอม',
      NAME_CONTRACT: 'ชื่อผู้ติดต่อ',
    },

    EMPLOYEE_WAGES: {
      TITLE: 'รายการค่าจ้างพนักงาน',
      ADD_EMPLOYEE_WAGES: 'บันทึกค่าจ้างพนักงาน',
      EDIT_EMPLOYEE_WAGES: 'แก้ไขค่าจ้างพนักงาน',
      DATE: 'วันที่',
      STAFF_TYPE: 'ประเภทพนักงาน',
      STATUS: 'สถานะ',
      DOC_NO: 'เลขที่เอกสาร',
      DOC_NO_DATE: 'วันที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      NAME: 'ชื่อพนักงาน',
      POSITION: 'ตำแหน่ง',
      WAGES: 'ค่าจ้าง(บาท)',
      OVERTIME: 'ค่าล่วงเวลา',
      SOCIAL_SECURITY: 'หักประกันสังคม',
      OTHER: 'หักอื่นๆ',
      WAGES_NET_WORTH: 'ค่าจ้าง(สุทธิ)',
      NOTE: 'หมายเหตุ',
      WAGES_AMOUNT: 'ค่าจ้าง(บาท)',
      WAGES_TOTAL: 'ยอดรวมค่าจ้างทั้งหมด',
      CODE: 'รหัสพนักงาน',
      PAY_DATE: 'วันที่จ่าย',
      WAGE: 'เงินเดือน/ค่าจ้าง',
    },

    MEMBER_DIVIDEND_PAYMENT: {
      TITLE: 'รายการจ่ายเงินปันผลสมาชิก',
      ADD_MEMBER_DIVIDEND_PAYMENT: 'บันทึกจ่ายเงินปันผลสมาชิก',
      EDIT_MEMBER_DIVIDEND_PAYMENT: 'แก้ไขจ่ายเงินปันผลสมาชิก',
      DATE: 'วันที่',
      STAFF_TYPE: 'ประเภทพนักงาน',
      STATUS: 'สถานะ',
      MEMBER: 'สมาชิก',
      SHARE_RATIO: 'สัดส่วนจำนวนหุ้น',
      AMOUNT_DIVIDENDS_PAID: 'จำนวนเงินปันผลที่จ่าย',
      MEMBER_HOLD_SHARE: 'สมาชิกที่ถือหุ้น',
      DOC_NO: 'เลขที่เอกสาร',
      DOC_NO_DATE: 'วันที่เอกสาร',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
    },

    OTHER_INCOME_ACCOUNT: {
      TITLE: 'รายการรายได้อื่น',
      ADD_OTHER_INCOME: 'บันทึกรายได้อื่น',
      EDIT_OTHER_INCOME: 'แก้ไขรายได้อื่น',
      DATE: 'วันที่',
      PAYMENT: 'ประเภทการรับเงิน',
      NET_WORTH_BAHT: 'มูลค่าสุทธิ(บาท)',
      STATUS: 'สถานะ',
      DOC_NO: 'เลขที่เอกสาร',
      DOC_NO_DATE: 'วันที่เอกสาร',
      PAYMENT_DATE: 'วันที่ชำระเงิน',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      CUSTOMER: 'ลูกค้า',
      ADDRESS: 'ที่อยู่',
      TAX_ID: 'เลขประจำตัวผู้เสียภาษี',
      SALE_PERSON: 'พนักงานขาย',
      NOTE: 'หมายเหตุ',
      LIST_OTHER_INCOME: 'รายการรายได้อื่นๆ',
      LIST: 'รายการ',
      DISCOUNT: 'ส่วนลด',
      VALUE: 'มูลค่า',
      PRICE_AFTER_DISCOUNT: 'ราคาหลังหักส่วนลด',
      HAS_VAT: 'มีภาษี',
      NO_VAT: 'ไม่มีภาษี',
      TOTAL: 'รวมทั้งหมด',
      UNIT: 'หน่วยนับ',
      VALUE_AFTER_DISCOUNT: 'มูลค่าหลังหักส่วนลด',
      TYPE_VAT: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      VALUE_NOT_VAT: 'มูลค่าไม่รวมภาษีมูลค่าเพิ่ม',
      VAT: 'ภาษีมูลค่าเพิ่ม',
      NET_WORTH: 'มูลค่าสุทธิ',
      AMOUNT: 'จำนวน',
      ITEM_NO_TAX: 'รายการสินค้าไม่มีภาษี',
      ITEM_TAX: 'รายการสินค้ามีภาษี',
      TAX_LIST: 'ภาษี',
      PRICE_BEFORE_TAX: 'ราคาก่อนภาษี',
      TOTAL_LIST: 'รวม',
      TOTAL_TABLE: 'รวมทั้งหมด',
      DISCOUNT_UNIT: 'หน่วยส่วนลด',
    },

    //Manage-farming
    ACTIVITY_TYPE: {
      TITLE: 'รายการประเภทกิจกรรม',
      ACTIVITY_TYPE: 'ประเภทกิจกรรม',
      ADD_ACTIVITY_TYPE: 'เพิ่มประเภทกิจกรรม',
      EDIT_ACTIVITY_TYPE: 'แก้ไขประเภทกิจกรรม',
    },
    ACTIVITY_INFORMATION: {
      TITLE: 'รายการผลิตปัจจุบัน',
      LOT: 'ผลิตภัณฑ์',
      AMOUNT_DAY: 'จำนวนวัน',
      CONTRACT: 'สัญญา',
      PLAN: 'แผนการผลิต',
      TITLE_ACTIVITY: 'กิจกรรมที่บันทึกแล้ว',
      CREATE_ACTIVITY: 'บันทึกกิจกรรม',
      START_DATE: 'วันที่เริ่มต้น',
      STEP: 'ขั้นตอน',
      HARVEST_DATE: 'วันที่เก็บเกี่ยว',
      STEP_TO_DO: 'ขั้นตอนที่จะต้องทำ',
      ACTIVITY: 'กิจกรรม',
      DATE: 'วันที่',
      TIME: 'เวลา',
      AMOUNT: 'จำนวน',
      RECCOMEND_AMOUNT: 'จำนวนที่แนะนำ',
      PRICE_UNIT: 'ราคาต่อหน่วย',
      EXPENSE: 'เลือกรายการค่าใช้จ่าย',
      FROM1: 'บันทึกสินค้าที่มีในคลัง',
      FROM2: 'บันทึกสินค้าที่ไม่มีในคลัง',
      FROM3: 'บันทึกค่าใช้จ่าย',
      FROM4: 'ฟอร์มสิ่งแวดล้อม',
      FROM5: 'ฟอร์มการเจริญเติบโต',
      FROM6: 'บันทึกเก็บเกี่ยวผลผลิต',
      PRODUCT_NON: 'เลือกรายการสินค้าที่ไม่มีในคลัง',
      PRODUCT: 'เลือกรายการสินค้าที่มีในคลัง',
      RAW_MAT: 'ผลผลิต',
      AMOUNT_STOCK: 'จำนวนคงคลัง',
      UNIT_STOCK: 'หน่วย(คงคลัง)',
      UNIT: 'หน่วย',
      REMARK: 'หมายเหตุ',
      MONEY: 'เงินรวม',
      DESCRIPTION: 'รายละเอียด',
      FARM: 'ชื่อฟาร์ม',
      STATUS: 'สถานะ',
      REF: 'อัางอิงจาก',
      REVERSE: 'ยกเลิก',
      REVERSED: 'ยกเลิกแล้ว',
    },
    FARMIHNG_ACTIVITY: {
      TITLE: 'รายการกิจกรรมการผลิต',
      NAME: 'ชื่อ',
      TYPE: 'ประเภท',
      RAW_MATERIAL: 'วัตถุดิบ',
      UNIT: 'หน่วยนับ',
      REMAIN: 'คงเหลือ',
      CATEGORY: 'ลักษณะ',
      ADD_FARMIHNG_ACTIVITY: 'เพิ่มกิจกรรมการผลิต',
      UPDATE_FARMIHNG_ACTIVITY: 'แก้ไขกิจกรรมการผลิต',
      SHOW_FARMIHNG_ACTIVITY: 'กิจกรรมการผลิต',
      ACTIVITY_NAME: 'ชื่อกิจกรรม',
      ACTIVITY_TYPE: 'ประเภทกิจกรรม',
      ACTIVITY_CATEGORY: 'ลักษณะกิจกรรม',
      CUT_STOCK: 'ตัดสต็อก',
      NO_CUT_STOCK: 'ไม่ตัดสต็อก',
      ADD_STOCK: 'เพิ่มสต็อก',
      CROP_REQUIREMENT: 'ค่ามาตรฐาน',
    },
    FARMIHNG_TYPE: {
      TITLE_LIST: 'รายการข้อมูลพื้นฐานการผลิต',
      TITLE_LIST_ADMIN: 'รายการข้อมูลพื้นฐานการผลิต (admin)',
      TITLE_ADD: 'รูปแบบการผลิต',
      FARMIHNG_TYPE: 'ข้อมูลพื้นฐานการผลิต',
      ADD_FARMIHNG_TYPE: 'เพิ่มรูปแบบการผลิต',
      EDIT_FARMIHNG_TYPE: 'แก้ไขรูปแบบการผลิต',
      FARMIHNG_NAME: 'ชื่อผลิตภัณฑ์',
      PROCEDURE_FARMIHNG: 'ขั้นตอนการผลิต',
      ADD_PROCEDURE_FARMIHNG: 'เพิ่มขั้นตอนการผลิต',
      PROCEDURE: 'ขั้นตอนที่',
      PROCEDURE_FARMIHNG_NAME: 'ชื่อขั้นตอนการผลิต',
      ACTIVITY: 'กิจกรรม',
      ADD_ACTIVITY: 'เพิ่มกิจกรรม',
      HARVEST_TYPE: 'จำนวนครั้งที่ได้รับผลผลิต/รอบการผลิต',
      HARVEST_CYCLE: 'ระยะเวลาที่สามารถเก็บเกี่ยวผลผลิต',
      START_YIELDING: 'ระยะเวลาที่เริ่มให้ผลผลิต',
      END_YIELDING: 'ระยะเวลาสิ้นสุดให้ผลผลิต',
      AMOUNT_SETUP_DATE: 'ระยะพักระหว่างรอบการผลิต (วัน)',
      AMOUNT_CYCLE: 'จำนวนครั้งของการให้ผลผลิตตลอดอายุ',
      IDLE_DATE: 'ระยะพักระหว่างรุ่น',
      AMOUNT_PRODUCT: 'เก็บเกี่ยวทุกกี่วัน(วัน)',
      YIELD_HAVEST: 'ผลผลิตต่อครั้งของการเก็บเกี่ยว',
      YIELD_FIELD: 'ผลผลิตรวมต่อรุ่น',
      YIELD_UNIT: 'หน่วย',
      AMOUNT_INITIAL: 'จำนวนวัตถุดิบที่ใช้ในการผลิต',
      INITIAL_UNIT: 'หน่วย',
      INITIAL_COST: 'ต้นทุนพันธุ์',
      FOOD_COST: 'ต้นทุนอาหาร',
      PROFIT: 'กำไร',
      CARCASS_PRICE: 'ราคาขาย',
      HARVEST_TYPE_FILTER: 'ประเภทของพืชหรือสัตว์',
      PRODUCT: 'วัตถุดิบที่ใช้ในการผลิต',
    },
    CROP_REQUIREMENT: {
      TITLE_LIST: 'รายการค่ามาตรฐาน',
      TITLE_LIST_ADMIN: 'รายการค่ามาตรฐาน (admin)',
      EDIT: 'แก้ไขค่ามาตรฐาน',
      CREATE: 'บันทึกค่ามาตรฐาน',
      NAME: 'ชื่อ',
      CONDITION_TYPE: 'ประเภทเงื่อนไข',
      UNIT: 'หน่วย',
      OWNER: 'ฟาร์ม',
      REF: 'ที่มา',
      FORMULA: 'สูตร',
      REQ_CONDITIONL: 'กำหนดเงื่อนไข',
      START_CONDITION: 'ช่วงอายุเริ่มต้น',
      END_CONDITION: 'ช่วงอายุสิ้นสุด',
      IS_DEFAULT: 'กำหนดเป็นช่วง',
      VALUE: 'ค่ามาตรฐาน',
      MIN: 'ค่าเริ่มต้น',
      MAX: 'ค่าสิ้นสุด',
    },
    ORDER_PLAN: {
      TITLE: 'รายการรับเข้าออเดอร์',
      ADD: 'สร้างใบรับเข้าออเดอร์',
      SHOW: 'ใบรับเข้าออเดอร์',
      DOC_NO: 'เลขที่เอกสาร',
      NAME: 'ชื่อลูกค้า',
      SHIPPING_ADDRESS: 'ส่งประจำทุกๆ',
      DATE: 'วันที่เอกสาร',
      RECEIVE_DATE: 'วันที่รับสินค้า',
      CONTRACT_TERM: 'ระยะเวลาสัญญา',
      END_DATE: 'วันที่สิ้นสุด',
      LIST: 'รายการ',
      AMOUNT: 'จำนวน',
      UNIT: 'หน่วยนับ',
      PROODUCTION_ORDER: 'สั่งผลิต',
      RECORDER: 'ผู้บันทึก',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      LIST_ORDER: 'รายการที่จะรับเข้าออเดอร์',
      ORDER: 'ออเดอร์',
      FARMER: 'เกษตกร',
      REVERSE: 'ยกเลิก',
    },
    ANALYZE_ORDERS: {
      TITLE: 'การวิเคราะห์',
      ADD: 'เพิ่มเกษตกรเข้าแปลง',
      CHOOSE: 'เลือกเกษตกร',
      SIZE: 'ขนาดพื้นที่',
      REMIAN: 'พื้นที่เหลือ',
      NAME: 'ชื่อผลผลิต',
      DEM: 'จำนวนการส่งต่อรอบ',
      DD: 'วันที่เริ่มรับสินค้า',
      DDCON: 'วันที่สิ้นสุดสัญญา',
      FD: 'ระยะห่าง แปลง/แปลง (วัน)',
      TDEM: 'Demand รวมตลอดทั้งสัญญา',
      TFD: 'ความถี่ในการส่งมอบ',
      FFR: 'อัตราส่วนระหว่างความถี่',
      DT: 'เริ่มให้ผลผลิต(วัน)',
      ST: 'เริ่มผลิตวันแรก',
      APOP: '(พื้นที่/จำนวนตัว)ที่ต้องผลิตต่อ 1 รอบการส่ง',
      AREA: 'พื้นที่ไร่ จำนวน/งาน ต่อ 1 รอบการผลิต(พื้นที่X4)',
      PRO: 'ออกผลผลิต',
      FPR: 'การตอบสนอง',
      FPFD: 'ช่วงเวลาเหลื่อมล้ำ',
      K22: 'K22',
      K21: 'K21',
      K13: 'K13',
      NK: 'จำนวนรอบการส่งมอบ',
      NB: 'จำนวนรุ่นที่ต้องผลิต (BATCH)',
      GB: 'ระยะห่างระหว่างรุ่น (Batch)',
      TPLOT: 'จำนวนรอบการผลิตทั้งหมด (ต้องเก็บเกี่ยว)',
      OP: 'ผลผลิตส่วนเกิน',
      PERCENT: '%',
      UNIT: 'หน่วย',
      AMOUNT_ROUND_PER_ITEM: 'จำนวนรอบต่อการผลิตต่อ 1 รุ่น',
    },
    REPORT_PLAN: {
      TITLE: 'รายงานวางแผนการผลิต',
    },
    FARMIHNG_INFORMATION: {
      TITLE: 'รายการบันทึกค่าการผลิต',
      ADD_FARMIHNG_INFORMATION: 'บันทึกค่าการผลิต',
      EDIT_FARMIHNG_INFORMATION: 'แก้ไขค่าการผลิต',
      FARMIHNG_INFORMATION: 'ค่าการผลิต',
      DATE: 'วันที่',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      ACTIVITY: 'กิจกรรม',
      RAW_MATERIAL: 'วัตถุดิบ',
      REMAIN: 'คงเหลือ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวน',
      TIME: 'เวลา',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
      FARMING: 'ฟาร์ม',
      AGENT: 'ตัวกลาง',
    },
    EXPENSE_FARMING_INFORMATION: {
      TITLE: 'รายการบันทึกค่าใช้จ่าย',
      EXPENSE_INFORMATION: 'ค่าใช้จ่าย',
      ADD_EXPENSE_INFORMATION: 'บันทึกค่าใช้จ่าย',
      EDIT_EXPENSE_INFORMATION: 'แก้ไขค่าใช้จ่าย',
      DATE: 'วันที่',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      ACTIVITY: 'กิจกรรม',
      AMOUNT: 'จำนวน',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
    },
    ENVIRONMENT_INFORMATION: {
      TITLE: 'รายการบันทึกค่าสิ่งแวดล้อม',
      ENVIRONMENT_INFORMATION: 'ค่าสิ่งแวดล้อม',
      ADD_ENVIRONMENT_INFORMATION: 'บันทึกค่าสิ่งแวดล้อม',
      EDIT_ENVIRONMENT_INFORMATION: 'แก้ไขค่าสิ่งแวดล้อม',
      DATE: 'วันที่',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      ACTIVITY: 'กิจกรรม',
      AMOUNT: 'จำนวน',
      TIME: 'เวลา',
      EVALUATE: 'วัดค่า',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
    },
    WASTING_INFORMATION: {
      TITLE: 'รายการบันทึกการสูญเสีย',
      WASTING_INFORMATION: 'การสูญเสีย',
      ADD_WASTING_INFORMATION: 'บันทึกการสูญเสีย',
      EDIT_WASTING_INFORMATION: 'แก้ไขการสูญเสีย',
      DATE: 'วันที่',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      ACTIVITY: 'กิจกรรม',
      AMOUNT: 'จำนวน',
      TIME: 'เวลา',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
    },
    GROWTH_INFORMATION: {
      TITLE: 'รายการบันทึกค่าการเจริญเติบโต',
      GROWTH_INFORMATION: 'ค่าการเจริญเติบโต',
      ADD_GROWTH_INFORMATION: 'บันทึกค่าการเจริญเติบโต',
      EDIT_GROWTH_INFORMATION: 'แก้ไขค่าการเจริญเติบโต',
      DATE: 'วันที่',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
      ACTIVITY: 'กิจกรรม',
      AMOUNT: 'จำนวน',
      ADD_AMOUNT: 'เพิ่มจำนวน',
    },
    HARVEST_INFORMATION: {
      TITLE: 'รายการบันทึกค่าการเก็บเกี่ยว',
      HARVEST_INFORMATION: 'ค่าการเก็บเกี่ยว',
      ADD_HARVEST_INFORMATION: 'บันทึกค่าการเก็บเกี่ยว',
      EDIT_HARVEST_INFORMATION: 'แก้ไขค่าการเก็บเกี่ยว',
      HAVEST: 'ข้อมูลการเก็บเกี่ยว',
      ADD_HARVEST: 'เพิ่มข้อมูล',
      DATE: 'วันที่',
      FARM_NAME: 'ชื่อฟาร์ม',
      TIME: 'เวลา',
      LOT: 'รุ่น',
      PROCEDURE: 'ขั้นตอน',
      FARMING_PROCEDURE: 'ขั้นตอนการผลิต',
      ACTIVITY: 'กิจกรรม',
      AMOUNT: 'จำนวน',
    },

    //Contract lot management
    CONTRACT_INFORMATION: {
      TITLE_LIST: 'รายการสัญญา ',
      TITLE_ADD: 'บันทึกสัญญา',
      TITLE_SHOW: 'ข้อมูลสัญญา',
      TITLE_EDIT: 'แก้ไขสัญญา',
      DOC_NO: 'เลขที่เอกสาร',
      MEMBER: 'สมาชิก',
      CONTRACT_NAME: 'ชื่อสัญญา',
      CONTRACT_DATE: 'วันที่ทำสัญญา',
      END_DATE: 'วันที่สิ้นสุด',
      INITIAL_RAW_MATERIAL: 'รายการวัตถุดิบตั้งต้น',
      CONTRACT_NO: 'หมายเลขสัญญา',
      FARMING_DATE: 'วันที่เลี้ยงจริง',
      PRODUCT: 'ผลผลิต',
      LOT_AMOUNT: 'จำนวนรุ่น',
      LOT_AMOUNT_PER: 'จำนวนต่อรุ่น',
      UNIT: 'หน่วยนับ',
      RAISING_AREA_TYPE: 'ประเภทพื้นที่การผลิต',
      RAISING_AREA_SIZE: 'ขนาดพื้นที่การผลิต',
      START_SIZE: 'ขนาดเริ่มต้นเลี้ยง',
      START_WEIGHT: 'น้ำหนักเริ่มต้นเลี้ยง',
      INSURANCE_PRICE: 'ราคาประกันผลผลิต',
      SECURITY_DEPOSIT: 'เงินประกัน',
      REVENUE_SHARE: 'การแบ่งสัดส่วนรายได้',
      WAGES: 'ค่าจ้าง',
      NOTE: 'หมายเหตุ',
      UNIT_ADD: 'หน่วย',
      IS_ANIMAL: 'เป็นประเภทสัตว์หรือไม่',
      ALL_AREA: 'ขนาดพื้นที่การผลิตทั้งหมด',
      AREA: 'ขนาดพื้นที่ที่ใช้',
      REMAIN: 'ขนาดพื้นที่ที่เหลือ',
      CANCEL: 'ยกเลิกสัญญา',
      CANCEL_DONE: 'ยกเลิกสัญญาแล้ว',
      STATUS: 'สถานะ',
      NORMAL: 'ปกติ',
    },
    LOT_INFORMATION: {
      TITLE_LIST: 'รายการรุ่น ',
      TITLE_ADD: 'บันทึกรุ่น',
      TITLE_EDIT: 'แก้ไขรุ่น',
      START_FARMING_DATE: 'วันที่เริ่มเลี้ยง',
      LOT_NAME: 'ชื่อรุ่น',
      INITIAL_RAW_MATERIAL: 'วัตถุดิบตั้งต้น',
      AMOUNT: 'จำนวน',
      UNIT: 'หน่วย',
      FARMING_TYPE: 'รูปแบบการผลิต',
      NUM_OF_FARMING_DATE: 'จำนวนวันที่เลี้ยง',
      DATE: 'วันที่',
      CONTRACT: 'สัญญา',
      INITIAL_AMOUNT: 'จำนวนตั้งต้น',
      UNIT_ADD: 'หน่วยนับ',
      IS_CLOSE: 'ปิดรุ่น',
      CLOSE_DATE: 'วันที่ปิดรุ่น',
      CHOOSE_CONTRACT: 'เลือกสัญญา',
    },

    //Report
    INVENTORY_REPORT: {
      SELECT_DATE_RANGE: 'เลือกช่วงวัน',
      UP_TO_DATE: 'ถึงวันที่',
      RAW_MAT: 'ชื่อวัตถุดิบ/ผลผลิต',
      DATE: 'วันที่',
    },

    PRODUCTION_EFFICIENCY: {
      PRODUCT_COST: {
        TITLE: 'รายงานต้นทุนผลิตรวม',
        CONTRACT: 'สัญญา',
        CHOOSE_CONTRACT: 'เลือกสัญญา',
        START_FARMING_DATE: 'วันที่เริ่มเลี้ยง',
        LOT: 'รุ่น',
        RAISING_PERIOD: 'ระยะเวลาในการผลิต (วัน)',
        TOTAL_COST: 'ต้นทุนรวม (บาท)',
        DETAILS: 'รายละเอียด',
        PROCEDURE_FARMING: 'ขั้นตอนการผลิต',
        FARMING_ACTIVITY: 'กิจกรรมการผลิต',
        CHOOSE_PROCEDURE_FARMIHNG: 'เลือกขั้นตอนการผลิต',
        CHOOSE_FARMING_ACTIVITY: 'เลือกกิจกรรมการผลิต',
        LIST: 'รายการ',
        TYPE: 'ประเภท',
        AMOUNT: 'ปริมาณ',
        UNIT: 'หน่วยนับ',
        AVERAGE_UNIT_PRICE: 'ราคาต่อหน่วยโดยเฉลี่ย',
        VALUE: 'มูลค่า (บาท)',
      },
      FEED_FERTILIZE_DRUG: {
        TITLE: 'รายงานการให้อาหาร / ใส่ปุ๋ย / ยา',
        SELECT_DATE_RANGE: 'เลือกช่วงวัน',
        UP_TO_DATE: 'ถึงวันที่',
        LIST: 'รายการ',
        CONTRACT: 'สัญญา',
        LOT: 'รุ่น',
        TYPE: 'ประเภท',
        AMOUNT: 'ปริมาณ',
        UNIT: 'หน่วยนับ',
        DETAILS: 'รายละเอียด',
      },
      GROWTH_REPORT: {
        TITLE: 'รายงานค่าการเจริญเติบโต',
        LIST: 'รายการ',
        CONTRACT: 'สัญญา',
        LOT: 'รุ่น',
        CHOOSE_LIST: 'เลือกรายการ',
        CHOOSE_CONTRACT: 'เลือกสัญญา',
        CHOOSE_LOT: 'เลือกรุ่น',
        AVERAGE_VOLUME: 'ปริมาณเฉลี่ย',
        UNIT: 'หน่วยนับ',
        DETAILS: 'รายละเอียด',
        NOTE: 'หมายเหตุ',
        DATE: 'วันที่',
        AMOUNT: 'ปริมาณ',
      },
      PRODUCT_QUANTITY: {
        TITLE: 'รายงานปริมาณผลผลิต',
        LIST: 'รายการ (ผลผลิต)',
        CONTRACT: 'สัญญา',
        LOT: 'รุ่น',
        CHOOSE_LIST: 'เลือกรายการ (ผลผลิต)',
        CHOOSE_CONTRACT: 'เลือกสัญญา',
        CHOOSE_LOT: 'เลือกรุ่น',
        FEEDING_PERIOD: 'ระยะเวลาเลี้ยง(วัน)',
        ESTIMATED_INCOME: 'รายได้ประมาณการ (บาท)',
        TOTAL: 'จำนวนผลผลิตรวม',
        DETAILS: 'รายละเอียด',
        START_DATE: 'วันที่เริ่มเลี้ยง',
        TOTAL_LIST: 'ผลรวมของแต่ละรายการ',
      },
      WASTING_REPORT: {
        TITLE: 'รายงานการสูญเสีย',
        LIST: 'รายการ (ผลผลิต)',
        CONTRACT: 'สัญญา',
        LOT: 'รุ่น',
        CHOOSE_LIST: 'เลือกรายการ (ผลผลิต)',
        CHOOSE_CONTRACT: 'เลือกสัญญา',
        CHOOSE_LOT: 'เลือกรุ่น',
        TOTAL_LOSS: 'สูญเสียรวม',
        FEEDING_PERIOD: 'ระยะเวลาเลี้ยง(วัน)',
        DETAILS: 'รายละเอียด',
        TOTAL_COST: 'ต้นทุนรวม (บาท)',
        START_DATE: 'วันที่เริ่มเลี้ยง',
        UNIT: 'หน่วยนับ',
        AMOUNT: 'ปริมาณ',
        DATE: 'วันที่',
        LIST_: 'รายการ',
        COST: 'ต้นทุน (บาท)',
      },
    },

    //Setting
    GENERAL_INFORMATION: {
      TITLE: 'ตั้งค่าข้อมูลทั่วไป',
      IMAGE: 'รูปแบรนด์/ฟาร์ม/องค์กร',
      NAME: 'ชื่อ ฟาร์ม/กิจการ',
      NAME_EN: 'ชื่อ ฟาร์ม/กิจการ(EN)',
      BRANCH_NAME: 'ชื่อสาขา',
      BRANCH_CODE: 'รหัสสาขา',
      TAX_ID: 'เลขประจำตัวผู้เสียภาษี',
      REGISTER: 'จดทะเบียน',
      VAT: 'คิดภาษีมูลค่าเพิ่ม',
      VAT_TYPE: 'วิธีคิดภาษีมูลค่าเพิ่ม',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      PHONE: 'เบอร์โทรศัพท์',
      EMAIL: 'อีเมล',
      FAX: 'แฟกส์',
      PROFIT: 'กำไรเป้าหมาย',
      TEXT_FOOTER_BILL: 'ข้อความท้ายใบเสร็จ/ใบแจ้งหนี้',
      IMAGE_FOOTER_BILL: 'รูปภาพท้ายใบเสร็จ/ใบแจ้งหนี้',
    },
    CUSTOMER_INFORMATION: {
      TITLE_LIST: 'รายชื่อลูกค้า',
      SHOW_LIST: 'ข้อมูลลูกค้า',
      CREATE: ' สร้างรายชื่อลูกค้า',
      EDIT: 'แก้ไขรายชื่อลูกค้า',
      NAME_LIST: 'ชื่อกิจการ',
      PHONE: 'เบอร์โทรศัพท์',
      TITLE: 'ตั้งค่าข้อมูลลูกค้า',
      NAME: 'ชื่อ บริษัท/ร้าน',
      TAX_ID: 'เลขประจำตัวผู้เสียภาษี',
      SHIPPING: 'ที่อยู่จัดส่ง',
      TAX_ADDRESS: 'ที่อยู่สำหรับออกใบเสร็จ/ใบกำกับภาษี',
      ADDRESS: 'ที่อยู่',
      SAME_ADDRESS: 'ที่อยู่เดียวกับที่อยู่ปัจจุบัน',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      CREDIT_DAY: 'เทอมการชำระเงิน',
      AMOUNT_DATE: 'จำนวนวัน',
      CONTACT_NAME: 'ชื่อผู้ติดต่อ',
      CONTACT_PHONE: 'เบอร์ผู้ติดต่อ',
      EMAIL: 'อีเมล',
      FAX: 'แฟกส์',
      CODE: 'รหัสลูกค้า',
      BRANCH: 'สาขา',
      BRANCH_CODE: 'รหัสสาขา',
      LINE: 'Line',
    },
    SUPPLIER_INFORMATION: {
      TITLE_LIST: 'รายชื่อผู้จำหน่าย',
      SHOW_LIST: 'ข้อมูลผู้จำหน่าย',
      CREATE: ' สร้างรายชื่อผู้จำหน่าย',
      EDIT: 'แก้ไขรายชื่อผู้จำหน่าย',
      NAME_LIST: 'ชื่อกิจการ',
      PHONE: 'เบอร์โทรศัพท์',
      TITLE: 'ตั้งค่าข้อมูลผู้จำหน่าย',
      NAME: 'ชื่อ บริษัท/ร้าน',
      TAX_ID: 'เลขประจำตัวผู้เสียภาษี',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      CREDIT_DAY: 'เทอมการชำระเงิน',
      AMOUNT_DATE: 'จำนวนวัน',
      CONTACT_NAME: 'ชื่อผู้ติดต่อ',
      EMAIL: 'อีเมล',
      FAX: 'แฟกส์',
      CODE: 'รหัสผู้จำหน่าย',
    },
    ACCOUNT_INFORMATION: {
      TITLE_LIST: 'รายชื่อบัญชีธนาคาร',
      BANK: 'ธนาคาร',
      ACCOUNT_NAME: 'ชื่อบัญชี',
      ACCOUNT_NUMBER: 'เลขบัญชี',
      ADD_BANK_ACCOUNT: 'เพิ่มบัญชีธนาคาร',
      EDIT_BANK_ACCOUNT: 'แก้ไขบัญชีธนาคาร',
      IS_QR_CODE: 'ใช้สำหรับ Qr code (พร้อมเพย์)',
      IS_CREDIT_CARD: 'ใช้สำหรับบัตรเครดิต',
    },
    EXPENSE_INFORMATION: {
      TITLE_LIST: 'รายการค่าใช้จ่าย',
      NAME: 'ชื่อค่าใช้จ่าย',
      DESCRIPTION: 'รายละเอียด',
      TYPE: 'ประเภทค่าใช้จ่าย',
      ADD_EXPENSE: 'เพิ่มชื่อค่าใช้จ่าย',
      EDIT_EXPENSE: 'แก้ไขชื่อค่าใช้จ่าย',
    },
    OTHER_INCOME: {
      TITLE_LIST: 'รายการรายได้อื่น',
      NAME: 'ชื่อรายได้อื่น',
      ADD_OTHER_INCOME: 'เพิ่มชื่อรายได้อื่น',
      EDIT_OTHER_INCOME: 'แก้ไขชื่อรายได้อื่น',
    },
    STAFF_INFORMATION: {
      TITLE_LIST: 'รายชื่อพนักงาน',
      TITLE_LIST_FARM: 'รายชื่อพนักงาน(ฟาร์ม)',
      TITLE_LIST_AGENT: 'รายชื่อพนักงาน(ตัวกลาง)',
      CREATE: ' สร้างรายชื่อพนักงาน',
      EDIT: 'แก้ไขรายชื่อพนักงาน',
      NAME_LIST: 'ชื่อ',
      USERNAME: 'ชื่อผู้ใช้',
      TITLE: 'ตั้งค่าพนักงาน',
      IMAGE: 'รูปภาพ',
      FIRST_NAME: 'ชื่อ',
      LAST_NAME: 'นามสกุล',
      NICK_NAME: 'ชื่อเล่น',
      PHONE: 'เบอร์โทรศัพท์',
      EMAIL: 'อีเมล',
      BIRTHDAY: 'วัน/เดือน/ปี เกิด',
      NO_ID: 'เลขประจำตัวประชาชน',
      CARD_ADDRESS: 'ที่อยู่ตามบัตรประชาชน',
      CURENT_ADDRESS: 'ที่อยู่ปัจจุบัน',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      SATRT_DATE: 'วันที่เริ่มทำงาน',
      END_DATE: 'วันที่สิ้นสุดการทำงาน',
      STAFF_POSITION: 'ตำแหน่งพนักงาน',
      STAFF_TYPE: 'ประเภทพนักงาน',
      SALARY: 'ค่าจ้าง/เงินเดือน',
      STAFF_STATUS: 'สถานะพนักงาน',
      PASSWORD: 'รหัสผ่าน',
      CON_PASSWORD: 'ยืนยันรหัสผ่าน',
      CHOOSE_DATE: 'เลือกวันที่',
      AMOUNT_SALARY: 'จำนวนเงิน',
      USERNAME_PLACEHODER: 'บัญชีผู้ใช้ (English&Number)',
      PASSEORD_PLACEHODER: 'รหัสผ่าน (English&Number)',
      CON_PASS_PLACEHODER: 'ยืนยันรหัสผ่าน (English&Number)',
      IS_PIN: 'สร้าง PIN',
      PIN: 'PIN',
      CON_PIN: 'ยืนยัน PIN',
      ADD: 'ที่อยู่ตามบัตรประชาชน',
      ROLE: 'สิทธิ์การใช้งาน',
      SYSTEM_ACCOUNT_NAME: 'ฟาร์ม',
      AGENT: 'ตัวกลาง',
    },
    PERMISSION: {
      TITLE_LIST: 'สิทธิ์การใช้งาน',
      NAME: 'สิทธิ์การใช้งาน',
      ADD_EXPENSE: 'เพิ่มสิทธิ์การใช้งาน',
      EDIT_EXPENSE: 'แก้ไขสิทธิ์การใช้งาน',
      NAME_POSITION: 'ชื่อตำแหน่ง',
    },
    POSITION: {
      TITLE_LIST: 'ตำแหน่งพนักงาน',
      NAME: 'ชื่อตำแหน่ง',
      ADD_EXPENSE: 'เพิ่มตำแหน่งพนักงาน',
      EDIT_EXPENSE: 'แก้ไขตำแหน่งพนักงาน',
      NAME_POSITION: 'ชื่อตำแหน่ง',
    },
    UNIT: {
      TITLE_LIST: 'รายการหน่วยนับ',
      NAME: 'ชื่อหน่วยนับ',
      ADD_UNIT: 'เพิ่มหน่วยนับ',
      EDIT_UNIT: 'แก้ไขหน่วยนับ',
    },
    RAW_MATERIAL_TYPE: {
      TITLE_LIST: 'รายการประเภทวัตถุดิบ/ผลผลิต',
      NAME: 'ชื่อประเภทวัตถุดิบ/ผลผลิต',
      CREDIT: 'ผังบัญชีรายได้',
      DEBIT: 'ผังบัญชีต้นทุน',
      ADD_RAW_MATERIAL: 'เพิ่มวัตถุดิบ/ผลผลิต',
      EDIT_RAW_MATERIAL: 'แก้ไขวัตถุดิบ/ผลผลิต',
    },
    RAW_MATERIAL_LIST: {
      TITLE_LIST: 'รายการวัตถุดิบ/ผลผลิต',
      TITLE_LIST_ADMIN: 'รายการวัตถุดิบ/ผลผลิต (admin)',
      CREATE: 'สร้างรายการวัตถุดิบ/ผลผลิต',
      EDIT: 'แก้ไขรายการวัตถุดิบ/ผลผลิต',
      NAME: 'ชื่อวัตถุดิบ',
      CODE: 'รหัสวัตถุดิบ',
      CODE_ADMIN: 'รหัสวัตถุดิบ(Admin)',
      BARCODE: 'บาร์โค้ด',
      STARDARD_PRICE: 'ราคาซื้อมาตรฐาน',
      MINIMUM_AMOUNT: 'จำนวนขั้นต่ำ',
      RAW_MATERIAL_TYPE: 'ประเภทวัตถุดิบ',
      IS_PRODUCT: 'สามารถเป็นผลผลิตได้',
      IS_VAT: 'มีภาษี',
      IS_EXPENSE: 'เป็นค่าใช้จ่าย',
      UNIT: 'หน่วยนับ',
      BATH: 'บาท',
      MULTIPLIER: 'ตัวคูณ',
      MAIN_UNIT: 'หน่วยหลัก',
      SUB_UNIT: 'หน่วยย่อย',
      TITLE: 'ตั้งค่าประเภทวัตถุดิบ/ผลผลิต',
      AMOUNT_EX: 'จำนวนวันหมดอายุ',
      EX_DATE: 'วันที่หมดอายุ',
    },
    INITIAL_CASH: {
      TITLE_LIST: 'รายการเงินสดตั้งต้น',
      AMOUNT: 'จำนวนเงินตั้งต้น',
      DATE: 'วันที่',
      SHOW_INITIAL_CASH: 'จำนวนเงินตั้งต้น',
      ADD_INITIAL_CASH: 'เพิ่มจำนวนเงินตั้งต้น',
      EDIT_INITIAL_CASH: 'แก้ไขจำนวนเงินตั้งต้น',
    },
    INITIAL_RAW_MATERIAL: {
      TITLE_LIST: 'รายการตั้งต้นวัตถุดิบ/สินค้า',
      TITLE_LIST_FARM: 'รายการตั้งต้นวัตถุดิบ/สินค้า (ฟาร์ม)',
      ADD: 'บันทึกค่าตั้งต้นวัตถุดิบ/สินค้า',
      ADD_FARM: 'บันทึกค่าตั้งต้นวัตถุดิบ/สินค้า (ฟาร์ม)',
      DATE: 'วันที่',
      DATE_CREATE: 'วันที่สร้าง',
      RAW_MATERIAL_TYPE: 'วัตถุดิบ/ผลผลิต',
      AMOUNT: 'จำนวนตั้งต้น',
      UNIT: 'หน่วยนับ',
      UNIT_COST: 'ต้นทุนต่อหน่วย',
      TOTAL: 'มูลค่า (บาท)',
      TITLE: 'ค่าตั้งต้นวัตถุดิบ/สินค้า',
      CHOOSE_DATE: 'เลือกวันที่',
      OWNER: 'เลือกฟาร์ม',
      OWNER_NAME: 'ฟาร์ม',
    },
    SHAREHOLDER_INFORMATION: {
      TITLE_LIST: 'รายการข้อมูลสมาชิกภายใต้การจ่ายเงินปันผล',
      CREATE: 'สร้างข้อมูลสมาชิกภายใต้การจ่ายเงินปันผล',
      EDIT: 'แก้ไขข้อมูลสมาชิกภายใต้การจ่ายเงินปันผล',
      AMOUNT: 'จำนวนหุ้น (หน่วย)',
      RATIO: 'สัดส่วน',
      PHONE: 'เบอร์โทรศัพท์',
      TITLE: 'ตั้งค่าข้อมูลสมาชิกภายใต้การจ่ายเงินปันผล',
      IMAGE: 'รูปภาพ',
      FIRST_NAME: 'ชื่อ',
      LAST_NAME: 'นามสกุล',
      NATIONALITY: 'สัญชาติ',
      AMOUNT_SHARE: 'จำนวนหุ้น',
      AMOUNT_PLACEHOLDER: 'จำนวน',
      UNIT: 'หน่วย',
      ADDRESS: 'ที่อยู่',
      PROVINCE: 'จังหวัด',
      TAMBON: 'ตำบล',
      AMPHUR: 'อำเภอ',
      POST_CODE: 'รหัสไปรษณีย์',
      SATRT_DATE: 'วันที่เริ่มทำงาน',
      MEMBER_NAME: 'ชื่อสมาชิก',
      SHARE_RATIO: 'สัดส่วนจำนวนหุ้น (%)',
      DIVIDEND_AMOUNT: 'จำนวนเงินปันผล',
      DIVIDEND_PAY_DATE: 'วันที่จ่ายเงินปันผล',
    },
    DIVIDEND_RATIOS: {
      TITLE_LIST: 'รายการอัตราส่วนเงินปันผล',
      AMOUNT: 'จำนวน (%)',
      NAME: 'ชื่ออัตราส่วน',
      ADD_DIVIDEND_RATIOS: 'เพิ่มอัตราส่วนเงินปันผล',
      EDIT_DIVIDEND_RATIOS: 'แก้ไขอัตราส่วนเงินปันผล',
    },
    WAREHOUSE_SETTING: {
      TITLE_LIST: 'ตั้งค่าคลังสินค้า',
      SETTING: 'เปิดใช้งาน',
      OPEN: 'เปิด',
      CLOSE: 'ปิด',
      NAME: 'ชื่อคลังสินค้า',
    },
    MENU_SETTING: {
      TITLE_LIST: 'รายการสินค้า',
      CREATE: 'สร้างรายการสินค้า',
      EDIT: 'แก้ไขเมนูสินค้า',
      IMAGE: 'รูปสินค้า',
      CODE_MENU: 'รหัสสินค้า',
      NAME: 'ชื่อสินค้า',
      RAW_MWTERIAL: 'รายการสินค้า',
      BARCODE: 'บาร์โค้ด',
      PRICE: 'ราคาขาย',
      WEIGHT: 'ขายตามน้ำหนัก',
      UNIT: 'หน่วยขาย',
      FEATURES: 'คุณสมบัติอื่นๆ',
      RECOMMENT: 'เป็นเมนูแนะนำ',
      PROMOTION: 'เกี่ยวกับโปรโมชั่น',
      NOT: 'ไม่เข้าร่วมโปรโมชั่น',
      SHOW_TIME: 'จำนวนวินาทีที่แสดงสินค้า',
    },
    PROMOTION_SETTING: {
      TITLE_LIST: 'รายการโปรโมชั่น',
      CREATE: 'สร้างโปรโมชั่น',
      EDIT: 'แก้ไขโปรโมชั่น',
      CODE: 'รหัสโปรโมชั่น',
      NAME: 'ชื่อโปรโมชั่น',
      TYPE: 'ประเภทโปรโมชั่น',
      STATUS: 'สถานะ',
      SETTING: 'เปิดใช้งาน',
      OPEN: 'เปิด',
      START_DATE: 'วันที่เริ่ม',
      END_DATE: 'วันที่สิ้นสุด',
      START_TIME: 'เวลาที่เริ่ม',
      END_TIME: 'เวลาที่สิ้นสุด',
      DESCRIPTION: 'รายละเอียด',
      DISCOUNT: 'ส่วนลด',
      UNIT: 'หน่วย',
      CONDITION: 'ประเภทโปรโมชั่น',
      PRODUCT: 'สินค้าร่วมรายการ',
      NON_DATE: 'ไม่กำหนดวันที่',
      NON_TIME: 'ไม่กำหนดช่วงเวลา',
    },
    CANCELLATION_SETTING: {
      TITLE_LIST: 'รายการเหตุผลการยกเลิก',
      CREATE: 'เพิ่มเหตุผลการยกเลิก',
      EDIT: 'แก้ไขเหตุผลการยกเลิก',
      NAME: 'ชื่อเหตุผลการยกเลิก',
    },
    PRINTER_SETTING: {
      TITLE_LIST: 'รายการข้อมูลเครื่องปริ้น',
      CREATE: 'เพิ่มข้อมูลเครื่องปริ้น',
      EDIT: 'แก้ไขข้อมูลเครื่องปริ้น',
      NAME: 'ชื่อเครื่องปริ้น',
      SIZE: 'ขนาดกระดาษ',
      TYPE: 'ประเภทการเชื่อมต่อ',
      PORT: 'Port',
      IP: 'IP Address',
    },
    POS_SETTING: {
      TITLE_LIST: 'รายการข้อมูลเครื่อง POS',
      CREATE: 'เพิ่มข้อมูลเครื่อง POS',
      EDIT: 'แก้ไขข้อมูลเครื่อง POS',
      STATUS: 'เป็น POS หลัก',
      NAME: 'ชื่อเครื่อง POS',
      CODE: 'รหัสออกใบเสร็จและใบแจ้งหนี้',
      NUMBER: 'หมายเลขเครื่องคิดเงิน',
      PRINTER: 'เครื่องปริ้น',
      TYPE: 'ประเภทการปริ้น',
      AMOUNT: 'จำนวนรอบ',
    },
    CATEGORY_SETTING: {
      TITLE_LIST: 'รายการหมวดหมู่สินค้า',
      CREATE: 'เพิ่มหมวดหมู่สินค้า',
      EDIT: 'แก้ไขหมวดหมู่สินค้า',
      TAB1: '1 รายละเอียดหมวดหมู่สินค้า',
      TAB2: '2 สินค้า',
      NUMBER: 'ลำดับ',
      NAME: 'ชื่อหมวดหมู่',
      READY: 'พร้อมจำหน่าย',
      READY_ALL: 'พร้อมจำหน่าย (ทั้งหมวดหมู่)',
      ORDER: 'เรียงลำดับการแสดง',
      NAME_PRODUCT: 'ชื่อสินค้า',
      PRODUCT: 'พร้อมจำหน่าย (ของสินค้า)',
      SHOW_BILL: 'โชว์ในใบเสร็จ',
      SHOW_DISPLAY: 'โชว์ในหน้าจอขาย',
    },
    ROUNDING_OFF_SETTING: {
      TAB1: 'ปัดเศษน้ำหนัก',
      TAB2: 'ปัดเศษท้ายบิล',
      ROUND_UP_WEIGHT: 'ปัดเศษน้ำหนักขึ้น',
      ROUND_DOWN_WEIGHT: 'ปัดเศษน้ำหนักลง',
      ROUND_UP: 'ปัดเศษขึ้น',
      ROUND_DOWN: 'ปัดเศษลง',
      BAHT: 'บาท',
      SALUNG: 'สลึง',
      CHOOSE: 'เลือกหน่วย',
    },
    TRANSFER_SETTING: {
      TITLE_LIST: 'รายการการโอนสินค้าระหว่างคลัง',
      CREATE: 'สร้างการโอนสินค้าระหว่างคลัง',
      EDIT: 'แก้ไขการโอนสินค้าระหว่างคลัง',
      SOURCE_WAREHOUSE: 'คลังต้นทาง',
      DESTINATION_WAREHOUSE: 'คลังปลายทาง',
      STATUS: 'สถานะ',
      DATE: 'วันที่เอกสาร',
      READ_FROM: 'อ่านจาก',
      REF_NO: 'เลขที่อ้างอิง',
      REF: 'อ้างอิงจาก',
      READ_FROM_ADJUST: 'อ่านจากใบปรับปรุงเดิม',
      RAW_MATERIAL: 'รายการวัตถุดิบ',
      PURCHASE: 'ใบซื้อวัตถุดิบสินค้า',
      RECEIVE: 'ใบรับซื้อผลผลิต',
      START_DATE: 'วันที่เริ่มต้น',
      END_DATE: 'วันที่สิ้นสุด',
      LIST: 'รายการ',
      UNIT: 'หน่วยนับ',
      AMOUNT: 'จำนวนในคลัง',
      AMOUNT_TRANFER: 'จำนวนที่โอน',
      UNIT_PRICE: 'ราคาต่อหน่วย',
      TOTAL_VALUE: 'รวมมูลค่า',
      TOTAL: 'รวมทั้งหมด',
    },
    DASHBOARD: {
      RAW_MATERIAL: 'ชื่อผลผลิต',
      LOT: 'ชื่อรุุ่น',
      AMOUNT: 'จำนวนผลผลิต',
      UNIT: 'หน่วยนับ',
      UNIT_BAHT: 'หน่วยนับ/บาท',
      TOTAL_COST: 'ต้นทุนรวม (รุ่น)',
      TOTAL_UNIT: 'ต้นทุน/หน่วย',
      PROFIT_UNIT: 'กำไรขั้นต้น/หน่วย (บาท/หน่วย)',
    },

    BTN: {
      EDIT: 'แก้ไข',
      MORE: 'เพิ่มเติม',
      ADD: 'เพิ่ม',
      DELETE: 'ลบ',
      CANCEL: 'ยกเลิก',
      SAVE: 'บันทึก',
      CLOSE: 'ปิด',
      ADD_LIST: 'เพิ่มรายการ',
      REVERSED: 'ยกเลิกแล้ว',
      REVERSE: 'ยกเลิก',
      EXPORT: 'ส่งออก',
      SEND: 'ส่ง',
      SEE_DETAILS: 'ดูรายละเอียด',
      PRINT: 'พิมพ์',
      COPY: 'คัดลอก',
      ALL_COPY: 'คัดลอกทั้งหมด',
      CLOSE_LOT: 'ปิดรุ่น',
      CLOSE_LOT_DONE: 'ปิดรุ่นแล้ว',
      PRINT_XLS: 'พิมพ์ xls',
      NEXT: 'ถัดไป',
      PREVIOUNS: 'ก่อนหน้า',
      CANCEL_LOT: 'ยกเลิกรุ่น',
      CANCEL_LOT_DONE: 'ยกเลิกรุ่นแล้ว',
      HAVE: 'มี',
      NOT_HAVE: 'ไม่มี',
      CAN: 'ได้',
      CAN_NOT: 'ไม่ได้',
      CANCEL_CONTRACT: 'ยกเลิกสัญญา',

      MENU_FARMING: {
        FARMING_INFORMATION: 'บันทึกค่าการผลิต',
        EXPENSE_INFORMATION: 'บันทึกค่าใช้จ่าย',
        ENVIRONMENT_INFORMATION: 'บันทึกค่าสิ่งแวดล้อม',
        WASTING_INFORMATION: 'บันทึกการสูญเสีย',
        GROWTH_INFORMATION: 'บันทึกค่าการเจริญเติบโต',
        HAVEST_INFORMATION: 'บันทึกค่าการเก็บเกี่ยว',
      },
    },
    INPUT: {
      SEARCH: 'ค้นหา',
      DATE: 'วันที่',
      OWNER: 'ฟาร์ม',
    },
    DATA_TABLE: {
      NO: 'ลำดับ',
      MANAGE: 'จัดการ',
      NO_DATA: 'ไม่พบข้อมูล',
      TOTAL: 'รวม',
    },
    ERROR: {
      IMAGE_OVER_SIZE: 'ขนาดไฟล์ต้องต้องไม่เกิน 500 kB',
    },
    PLACEHOLDER: {
      PROVINCE: 'เลือกจังหวัด',
      AMPHUR: 'เลือกอำเภอ',
      TAMBON: 'เลือกตำบล',
      POSITION: 'เลือกตำแหน่ง',
      STAFF_TYPE: 'เลือกประเภทพนักงาน',
      STAFF_STATUS: 'เลือกสถานะพนักงาน',
      ACCEPT_DEBTPERMISSION: 'เลือกสิทธิ์การใช้งาน',
      RAW_MATERIAL_TYPE: 'เลือกประเภทวัตถุดิบ',
      DATE: 'เลือกวันที่',
      YEAR: 'เลือกปี',
      TIME: 'เลือกเวลา',
      RAW_MATERIAL: 'เลือกวัตถุดิบและผลผลิต',
      BATH: 'บาท',
      UNIT: 'หน่วย',
      DAY: 'วัน',
      SEC: 'วินาที',
      FARM: 'ไร่',
    },
    VALIDATOR: {
      REQUIRED: 'กรุณากรอกข้อมูล',
      MIN: 'กรุณากรอกค่าที่มากกว่า',
      MAX: 'กรุณากรอกค่าที่น้อยกว่านี้',
      EMAIL: 'อีเมลไม่ถูกต้อง',
      MUST_MATCH: 'รหัสผ่านไม่ตรงกัน',
      PATTERN: 'กรุณาระบุเป็นตัวอักษรภาษาอังกฤษหรือตัวเลข (a-z, A-Z, 0-9) เท่านั้น',
      MIN_LENGTH: 'จำนวนตัวอักษรขั้นต่ำ',
      MAX_LENGTH: 'จำนวนตัวอักษรไม่เกิน',
      LENGTH_VAR: 'ตัวอักษร',
      PIN_MUST_MATCH: 'Pin ไม่ตรงกัน',
      DUPLICATE: 'ข้อมูลซ้ำ',
    },

    FILTERS: {
      THB: 'บาท',
      PERCENT: 'เปอร์เซ็น',
      REEIVE: 'ใบรับเข้า',
      EXPENSE: 'ค่าใช้จ่าย',
      PURCHASE_PRODUCT: 'ใบรับซื้อ',
      PURCHASE: 'ใบซื้อ',
      PAYMENT_1: 'ชำระบางส่วน',
      PAYMENT_2: 'ชำระเต็มจำนวน',
      SALE: 'ใบขายวัตถุดิบ/ผลผลิต/อุปกรณ์ (ลูกค้า)',
      SALE_SYSTEM_ACCOUNT: 'ใบขายวัตถุดิบ/ผลผลิต/อุปกรณ์ (สมาชิก)',
      OTHER_INCOME: 'ใบรายได้อื่นๆ',
      AGENT: 'ตัวกลาง',
      FARM: 'ฟาร์ม',
      SEFL: 'ตัวเอง',
      ALL_BILL: 'ทั้งบิล',
      CATEGORY: 'รายหมวดหมู่',
      PRODUCT: 'รายสินค้า',
      YEAR: 'ปี',
      LIST_NAME_AGENT: 'รายชื่อพนักงาน(ตัวกลาง)',
    },

    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
  },
};
